// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bv-hero {
  position: relative;
  overflow-x: clip;
  overflow-y: visible;
  background:
    radial-gradient(
      900px 460px at 8% 12%,
      rgba(20, 184, 166, 0.1),
      transparent 60%
    ),
    radial-gradient(
      700px 420px at 90% 88%,
      rgba(20, 184, 166, 0.1),
      transparent 65%
    ),
    var(--bv-bg);
  padding: clamp(1.5rem, 3vw, 2.5rem) 0 var(--bv-space-9);
}

.bv-hero__inner {
  max-width: calc(var(--bv-container-wide) + (2 * var(--bv-container-px)));
  margin-inline: auto;
  padding-inline: var(--bv-container-px);
  box-sizing: border-box;
  position: relative;
}

.bv-hero__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);
  gap: clamp(1.5rem, 3vw, 3rem);
  align-items: center;
  position: relative;
  z-index: 2;
}

.bv-hero__deco {
  pointer-events: none;
  position: absolute;
  z-index: 1;
}

.bv-hero__deco img {
  width: 100%;
  height: auto;
}

.bv-hero__deco--hotel {
  top: 30px;
  left: 52%;
  width: 64px;
  animation: bvFloatSpin 6s ease-in-out infinite;
}

.bv-hero__deco--soccer {
  top: -30px;
  left: 72%;
  width: 64px;
  animation: bvFloatSpin 6s ease-in-out infinite;
}

.bv-hero__deco--shuttle {
  top: 8%;
  right: 1%;
  width: 76px;
  animation: bvFloat 5s ease-in-out infinite 0.4s;
}

.bv-hero__copy {
  position: relative;
  z-index: 5;
  animation: bvFadeUp 0.7s var(--bv-ease-out) both;
}

.bv-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: var(--bv-space-2);
  padding: 8px 16px;
  border-radius: var(--bv-radius-pill);
  border: 1px solid var(--bv-primary-line);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  margin-bottom: var(--bv-space-5);
}

.bv-hero__eyebrow i {
  color: var(--bv-primary);
}

.bv-hero__title {
  margin: 0 0 var(--bv-space-5);
  line-height: 1;
  letter-spacing: -0.025em;
}

.bv-hero__title-line {
  display: block;
  font-family: var(--bv-font-display);
  font-size: var(--bv-display);
  font-weight: 800;
  color: var(--bv-ink);
}

.bv-hero__title-line--teal {
  color: var(--bv-primary);
}

.bv-hero__title-line--script {
  font-family: var(--bv-font-script);
  font-size: var(--bv-display-script);
  font-weight: 700;
  color: var(--bv-ink);
  position: relative;
  display: inline-block;
  padding-bottom: 6px;
}

.bv-hero__title-line--script::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 70%;
  height: 8px;
  background: var(--bv-primary);
  border-radius: var(--bv-radius-pill);
  opacity: 0.85;
  transform: skewX(-8deg);
}

.bv-hero__lede {
  color: var(--bv-muted);
  font-size: var(--bv-text-lg);
  max-width: 520px;
  margin-bottom: var(--bv-space-6);
}

.bv-hero__search-wrap {
  position: relative;
  max-width: 560px;
  margin-bottom: var(--bv-space-6);
  z-index: 30;
  overflow: visible;
}

.bv-hero__copy:has(.bv-hero__search-wrap.is-focused) {
  z-index: 12;
}

.bv-hero__search-wrap.is-focused {
  z-index: 45;
}

.bv-hero__search-wrap.is-focused ~ .bv-hero__chips {
  position: relative;
  z-index: 0;
}

.bv-hero__search {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  padding: 6px 6px 6px 10px;
  border-radius: var(--bv-radius-pill);
  border: 1px solid var(--bv-line);
  box-shadow: var(--bv-shadow);
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.bv-hero__search-wrap.is-focused .bv-hero__search {
  border-color: var(--bv-primary);
  box-shadow:
    0 0 0 4px rgba(20, 184, 166, 0.12),
    var(--bv-shadow-md);
}

.bv-hero__search-pin {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--bv-primary);
  flex-shrink: 0;
}

.bv-hero__search-input {
  flex: 1 1;
  min-width: 0;
}

.bv-hero__search-input .search-container-head {
  width: 100%;
}

.bv-hero__search-input .search-bar-wrapper {
  border: 0;
  position: relative;
}

.bv-hero__search-input .search-bar-wrapper > svg {
  display: none;
}

.bv-hero__search-input .suggestionList {
  display: none;
}

.bv-hero__search-input input.form-control {
  border: none !important;
  background: transparent !important;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base) !important;
  color: var(--bv-ink-2);
  padding: 10px 8px !important;
  height: auto !important;
  line-height: 1.4 !important;
  box-shadow: none !important;
}

.bv-hero__search-input input.form-control::placeholder {
  color: var(--bv-muted-2);
}

.bv-hero__search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
  flex-shrink: 0;
  transition: transform var(--bv-dur) var(--bv-ease);
}

.bv-hero__search-btn:hover {
  transform: scale(1.06);
}

.bv-hero__search-input .suggestionList {
  position: absolute;
  top: calc(100% + 16px);
  left: -8px;
  right: -50px;
  max-height: 260px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-lg);
  box-shadow: var(--bv-shadow-md);
  padding: 10px;
  z-index: 60;
  list-style: none;
}

.bv-hero__search-input .suggestion-item {
  padding: 10px 12px;
  border-radius: var(--bv-radius-sm);
  cursor: pointer;
  transition: background var(--bv-dur-fast) var(--bv-ease);
}

.bv-hero__search-input .suggestion-item:hover {
  background: var(--bv-primary-50);
}

.bv-hero__search-input .suggestion-heading {
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-ink-2);
  margin: 0;
}

.bv-hero__search-input .suggestion-desc {
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  margin: 0;
}

.bv-hero__search-panel {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-xl);
  box-shadow: var(--bv-shadow-lg);
  padding: 12px;
  z-index: 50;
  max-height: min(420px, 55vh);
  overflow-y: auto;
  overscroll-behavior: contain;
  animation: bvFadeUp 0.18s var(--bv-ease-out) both;
}

.bv-hero__search-cta {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: none;
  padding: 12px 14px;
  border-radius: var(--bv-radius);
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-ink);
  cursor: pointer;
  transition: background var(--bv-dur-fast) var(--bv-ease);
}

.bv-hero__search-cta i {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--bv-primary);
}

.bv-hero__search-cta:hover {
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
}

.bv-hero__search-sub {
  padding: 10px 14px 6px;
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
}

.bv-hero__search-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.bv-hero__search-list li button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: none;
  padding: 10px 14px;
  border-radius: var(--bv-radius);
  font-size: var(--bv-text-sm);
  color: var(--bv-ink-2);
  text-align: left;
  cursor: pointer;
  transition: background var(--bv-dur-fast) var(--bv-ease);
}

.bv-hero__search-list li button:hover {
  background: var(--bv-primary-50);
}

.bv-hero__search-list li button i {
  color: var(--bv-muted);
  width: 16px;
}

.bv-hero__search-list li button em {
  font-style: normal;
  color: var(--bv-muted);
  font-size: var(--bv-text-xs);
  margin-left: auto;
}

.bv-hero__chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--bv-space-3);
}

.bv-hero__chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px 6px 6px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-line);
  color: var(--bv-ink-2);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--bv-dur) var(--bv-ease);
}

.bv-hero__chip-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bv-bg-soft);
  border: 1px solid var(--bv-line);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 3px;
}

.bv-hero__chip-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.bv-hero__chip:hover {
  border-color: var(--bv-primary);
  color: var(--bv-primary-700);
  box-shadow: var(--bv-shadow-sm);
  transform: translateY(-2px);
}

.bv-hero__showcase {
  position: relative;
  min-height: clamp(420px, 56vh, 580px);
  z-index: 1;
  animation: bvFadeUp 0.8s var(--bv-ease-out) 0.1s both;
}

.bv-stage {
  position: relative;
  width: 100%;
  height: clamp(420px, 56vh, 580px);
  isolation: isolate;
}

button.bv-stage__card {
  border: 5px solid #fff;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.bv-stage__card {
  position: absolute;
  border-radius: var(--bv-radius-xl);
  overflow: hidden;
  background: #fff;
  border: 5px solid #fff;
  box-shadow: var(--bv-shadow-lg);
  transform-origin: center center;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transition:
    transform 0.38s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.38s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;
}

.bv-stage__card--1 {
  width: 30%;
  height: 56%;
  left: -2%;
  top: 30%;
  z-index: 1;
  transform: rotate(-18deg);
}

.bv-stage__card--2 {
  width: 36%;
  height: 72%;
  left: 12%;
  top: 13%;
  z-index: 2;
  transform: rotate(-9deg);
}

.bv-stage__card--3 {
  width: 42%;
  height: 88%;
  left: 50%;
  top: 3%;
  z-index: 4;
  transform: translateX(-50%);
}

.bv-stage__card--4 {
  width: 36%;
  height: 72%;
  right: 12%;
  top: 13%;
  z-index: 2;
  transform: rotate(9deg);
}

.bv-stage__card--5 {
  width: 30%;
  height: 56%;
  right: -2%;
  top: 30%;
  z-index: 1;
  transform: rotate(18deg);
}

.bv-stage__card:hover {
  box-shadow: var(--bv-shadow-xl);
  z-index: 10;
}

.bv-stage__card--1:hover {
  transform: rotate(-18deg) scale(1.04);
}

.bv-stage__card--2:hover {
  transform: rotate(-9deg) scale(1.04);
}

.bv-stage__card--3:hover {
  transform: translateX(-50%) scale(1.04);
}

.bv-stage__card--4:hover {
  transform: rotate(9deg) scale(1.04);
}

.bv-stage__card--5:hover {
  transform: rotate(18deg) scale(1.04);
}

.bv-stage__card:not(:hover) {
  will-change: auto;
}

.bv-stage__photo {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.bv-stage__tag {
  position: absolute;
  left: 12px;
  bottom: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  border-radius: var(--bv-radius);
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
  text-align: left;
}

.bv-stage__tag-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  font-size: 12px;
}

.bv-stage__tag-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bv-stage__tag-cat {
  font-size: 10px;
  text-transform: uppercase;
  color: var(--bv-muted);
  letter-spacing: 0.04em;
  font-weight: 600;
}

.bv-stage__tag-name {
  font-size: var(--bv-text-sm);
  font-weight: 700;
  color: var(--bv-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bv-stage__tag-price {
  font-size: 11px;
  color: var(--bv-primary-700);
  font-weight: 700;
}

.bv-stage__tag-icon--tennis {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.bv-stage__tag-icon--basketball {
  background: linear-gradient(135deg, #fb923c, #ea580c);
}

.bv-stage__tag-icon--football {
  background: linear-gradient(135deg, #14b8a6, #0d9488);
}

.bv-stage__tag-icon--cricket {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.bv-stage__tag-icon--badminton {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.bv-hero__strip {
  position: relative;
  z-index: 1;
  margin-top: var(--bv-space-8);
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: clamp(1.5rem, 3vw, 3rem);
  flex-wrap: wrap;
}

.bv-hero__strip > * {
  flex: 1 1 360px;
  min-width: 0;
}

.bv-app-pill {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--bv-space-4);
  padding: 10px 14px 10px 12px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-line);
  box-shadow: var(--bv-shadow);
  max-width: 590px;
}

.bv-app-pill__icon {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 20px;
  box-shadow: 0 6px 18px rgba(20, 184, 166, 0.36);
}

.bv-app-pill__dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--bv-success);
  border: 2px solid #fff;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);
  animation: bvPulseRing 2s ease-out infinite;
}

.bv-app-pill__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bv-app-pill__text strong {
  font-family: var(--bv-font-display);
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--bv-ink);
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.bv-app-pill__text span {
  font-size: 0.74rem;
  color: var(--bv-muted);
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bv-app-pill__btns {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.bv-store-btn {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: #fff;
  color: var(--bv-primary-700);
  border: 1.5px solid var(--bv-primary-line);
  padding: 7px 14px;
  border-radius: var(--bv-radius);
  text-decoration: none;
  transition:
    transform var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
  flex-shrink: 0;
  white-space: nowrap;
}

.bv-store-btn i {
  font-size: 20px;
  line-height: 1;
  color: var(--bv-primary-700);
  transition: color var(--bv-dur) var(--bv-ease);
}

.bv-store-btn span {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  text-align: left;
  font-family: var(--bv-font-display);
  font-size: 0.82rem;
  font-weight: 800;
  color: var(--bv-ink);
}

.bv-store-btn em {
  font-style: normal;
  font-weight: 600;
  font-size: 8.5px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--bv-primary-700);
  margin-bottom: 1px;
  opacity: 0.85;
}

.bv-store-btn:hover {
  transform: translateY(-2px);
  background: var(--bv-grad-primary);
  border-color: transparent;
  color: #fff;
  box-shadow: 0 12px 24px rgba(20, 184, 166, 0.32);
}

.bv-store-btn:hover i,
.bv-store-btn:hover span,
.bv-store-btn:hover em {
  color: #fff;
}

.bv-stats-pill {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 18px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-line);
  box-shadow: var(--bv-shadow);
  max-width: 590px;
}

.bv-stats-pill__avatars {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.bv-stats-pill__avatars img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #fff;
  object-fit: cover;
  background: var(--bv-bg-soft);
  margin-left: -10px;
  box-shadow: var(--bv-shadow-xs);
}

.bv-stats-pill__avatars img:first-child {
  margin-left: 0;
}

.bv-stats-pill__item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex-shrink: 0;
}

.bv-stats-pill__item--avatars {
  gap: 12px;
}

.bv-stats-pill__txt {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  min-width: 0;
}

.bv-stats-pill__txt strong {
  font-family: var(--bv-font-display);
  font-size: 1rem;
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.01em;
  line-height: 1.1;
}

.bv-stats-pill__txt span {
  font-size: 11px;
  color: var(--bv-muted);
  white-space: nowrap;
  font-weight: 500;
}

.bv-stats-pill__item--reverse .bv-stats-pill__txt {
  text-align: right;
}

.bv-stats-pill__icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 15px;
  position: relative;
}

.bv-stats-pill__icon--star {
  background: linear-gradient(135deg, #fde68a, #f59e0b);
  color: #fff;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.32);
}

.bv-stats-pill__icon--venue {
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.32);
}

.bv-stats-pill__divider {
  width: 1px;
  height: 30px;
  background: var(--bv-line);
  flex-shrink: 0;
}

@media (max-width: 1100px) {
  .bv-hero__grid {
    grid-template-columns: 1fr;
  }

  .bv-hero__deco {
    display: none !important;
  }

  .bv-hero__showcase {
    min-height: 320px;
  }

  .bv-stage {
    max-width: 560px;
    margin-inline: auto;
    height: 320px;
  }

  .bv-hero__strip {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-top: var(--bv-space-6);
  }

  .bv-hero__strip > * {
    flex: none;
    width: 100%;
    max-width: 100%;
  }

  /* App pill — vertical card layout */
  .bv-app-pill {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px 12px;
    padding: 14px;
    border-radius: 20px;
    max-width: 100%;
    width: 100%;
  }

  .bv-app-pill__icon {
    width: 42px;
    height: 42px;
    font-size: 18px;
    flex-shrink: 0;
  }

  .bv-app-pill__text {
    flex: 1 1;
    min-width: 0;
  }

  .bv-app-pill__text span {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  .bv-app-pill__btns {
    flex: 1 1 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .bv-app-pill__btns .bv-store-btn {
    min-width: 0;
    width: 100%;
    justify-content: center;
    padding: 8px 6px;
    white-space: normal;
  }

  /* Stats pill — 3 equal columns, dividers removed from flow */
  .bv-stats-pill {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: start;
    gap: 10px 6px;
    padding: 14px 10px;
    border-radius: 20px;
    max-width: 100%;
    width: 100%;
  }

  .bv-stats-pill__divider {
    display: none !important;
  }

  .bv-stats-pill__item,
  .bv-stats-pill__item--avatars,
  .bv-stats-pill__item--reverse {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    text-align: center;
    min-width: 0;
    width: 100%;
  }

  .bv-stats-pill__item--reverse .bv-stats-pill__txt {
    order: 2;
    text-align: center;
  }

  .bv-stats-pill__item--reverse .bv-stats-pill__icon {
    order: 1;
  }

  .bv-stats-pill__item--reverse .bv-stats-pill__txt {
    text-align: center;
  }

  .bv-stats-pill__avatars {
    justify-content: center;
  }

  .bv-stats-pill__txt {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .bv-stats-pill__txt span {
    white-space: normal;
    line-height: 1.2;
  }
}

@media (max-width: 768px) {
  .bv-hero {
    overflow-x: clip;
    padding: 1.25rem 0 var(--bv-space-7);
  }

  .bv-hero__inner {
    padding-inline: 16px;
  }

  /* Hide main heading on mobile — eyebrow carries the hero message */
  .bv-hero__title {
    display: none;
  }

  .bv-hero__eyebrow {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 13px 18px;
    margin-bottom: var(--bv-space-5);
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.01em;
    border-radius: 14px;
    background: linear-gradient(90deg, var(--bv-primary-50) 0%, #ecfdf5 100%);
    box-shadow: 0 4px 16px rgba(20, 184, 166, 0.12);
  }

  .bv-hero__eyebrow i {
    font-size: 1.05rem;
    flex-shrink: 0;
  }

  .bv-hero__lede {
    font-size: 0.92rem;
    line-height: 1.55;
    margin-bottom: var(--bv-space-5);
  }

  .bv-hero__search-wrap {
    max-width: 100%;
    margin-bottom: var(--bv-space-5);
  }

  .bv-hero__search-btn {
    width: 38px;
    height: 38px;
    font-size: 14px;
  }

  .bv-hero__chips {
    gap: 8px;
  }

  .bv-hero__chip {
    padding: 5px 12px 5px 5px;
    font-size: 0.78rem;
  }

  .bv-hero__showcase {
    min-height: 320px;
    margin-top: 10px;
  }

  .bv-stage {
    height: 320px;
    max-width: 100%;
  }

  .bv-stage__card {
    border-width: 4px;
  }

  .bv-stage__card--1,
  .bv-stage__card--5 {
    display: none;
  }

  .bv-stage__card--2 {
    width: 44%;
    height: 80%;
    left: 0;
    top: 12%;
    transform: rotate(-9deg);
  }

  .bv-stage__card--2:hover {
    transform: rotate(-9deg) scale(1.04);
  }

  .bv-stage__card--3 {
    width: 52%;
    height: 92%;
    left: 50%;
    top: 4%;
    z-index: 4;
    transform: translateX(-50%);
  }

  .bv-stage__card--3:hover {
    transform: translateX(-50%) scale(1.04);
  }

  .bv-stage__card--4 {
    width: 44%;
    height: 80%;
    right: 0;
    top: 12%;
    transform: rotate(9deg);
  }

  .bv-stage__card--4:hover {
    transform: rotate(9deg) scale(1.04);
  }

  .bv-stage__tag {
    display: none;
  }

  .bv-hero__search-input .suggestionList {
    right: 0;
    left: 0;
  }
}

@media (max-width: 480px) {
  .bv-hero__eyebrow {
    font-size: 0.9rem;
    padding: 12px 16px;
    gap: 9px;
  }

  .bv-hero__eyebrow i {
    font-size: 1rem;
  }

  .bv-hero__chip-icon {
    width: 26px;
    height: 26px;
  }

  .bv-hero__showcase {
    min-height: 290px;
  }

  .bv-stage {
    height: 290px;
  }

  .bv-stage__card--2 {
    width: 46%;
    height: 82%;
  }

  .bv-stage__card--3 {
    width: 54%;
    height: 94%;
    top: 3%;
  }

  .bv-stage__card--4 {
    width: 46%;
    height: 82%;
  }

  .bv-app-pill {
    padding: 12px;
    gap: 8px;
  }

  .bv-app-pill__icon {
    width: 38px;
    height: 38px;
    font-size: 16px;
  }

  .bv-app-pill__text strong {
    font-size: 0.88rem;
  }

  .bv-app-pill__text span {
    font-size: 0.7rem;
  }

  .bv-store-btn {
    padding: 7px 4px;
    gap: 6px;
  }

  .bv-store-btn i {
    font-size: 16px;
  }

  .bv-store-btn span {
    font-size: 11px;
  }

  .bv-store-btn em {
    font-size: 7px;
  }

  .bv-stats-pill {
    padding: 12px 6px;
    gap: 8px 4px;
  }

  .bv-stats-pill__avatars img {
    width: 22px;
    height: 22px;
    margin-left: -7px;
  }

  .bv-stats-pill__icon {
    width: 28px;
    height: 28px;
    font-size: 12px;
    border-radius: 8px;
  }

  .bv-stats-pill__txt strong {
    font-size: 0.82rem;
  }

  .bv-stats-pill__txt span {
    font-size: 9px;
  }
}

.bv-offers {
  background: var(--bv-bg);
  padding: clamp(1rem, 2vw, 1.75rem) 0;
}

.bv-offers__pill {
  max-width: var(--bv-container-wide);
  margin-inline: auto;
  padding: 10px 18px 10px 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1px solid rgba(20, 184, 166, 0.18);
  box-shadow: 0 8px 30px rgba(20, 184, 166, 0.08);
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  position: relative;
}

.bv-offers__badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 18px 6px 6px;
  border-radius: 999px;
  background: #fff;
  color: var(--bv-primary-700);
  border: 1.5px solid rgba(20, 184, 166, 0.3);
  box-shadow: 0 6px 18px rgba(20, 184, 166, 0.14);
  flex-shrink: 0;
  position: relative;
}

.bv-offers__badge-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  box-shadow: 0 6px 14px rgba(20, 184, 166, 0.32);
  position: relative;
}

.bv-offers__badge-icon::after {
  content: "";
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  border: 1.5px solid rgba(20, 184, 166, 0.32);
  animation: bvBadgeRing 2.2s ease-out infinite;
}

@keyframes bvBadgeRing {
  0% {
    transform: scale(0.92);
    opacity: 0.8;
  }

  70% {
    transform: scale(1.2);
    opacity: 0;
  }

  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}

.bv-offers__badge-text {
  font-family: var(--bv-font-display);
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  white-space: nowrap;
  text-transform: uppercase;
  background: linear-gradient(
    90deg,
    var(--bv-primary-700) 0%,
    var(--bv-primary) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bv-offers__track-wrap {
  overflow: hidden;
  position: relative;
  min-width: 0;
  mask-image: linear-gradient(
    90deg,
    transparent 0,
    #000 4%,
    #000 96%,
    transparent 100%
  );
}

.bv-offers__track {
  display: inline-flex;
  align-items: center;
  gap: 0;
  width: max-content;
  animation: bvOffersScroll 36s linear infinite;
}

.bv-offers:hover .bv-offers__track {
  animation-play-state: paused;
}

@keyframes bvOffersScroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

.bv-offers__group {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.bv-offers__item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 4px 14px;
  white-space: nowrap;
  flex-shrink: 0;
}

.bv-offers__item-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid rgba(20, 184, 166, 0.18);
  color: var(--bv-primary-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(20, 184, 166, 0.1);
}

.bv-offers__item-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.bv-offers__item-text > span {
  font-family: var(--bv-font-display);
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--bv-ink);
}

.bv-offers__item-text > span strong {
  color: var(--bv-primary-700);
  font-weight: 800;
}

.bv-offers__item-text em {
  font-style: normal;
  font-size: 0.74rem;
  font-weight: 500;
  color: var(--bv-muted);
  margin-top: 2px;
}

.bv-offers__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--bv-primary);
  opacity: 0.55;
  flex-shrink: 0;
  margin-inline: 4px;
}

@media (max-width: 768px) {
  .bv-offers__pill {
    border-radius: 28px;
    padding: 8px 12px 8px 8px;
    gap: 10px;
  }

  .bv-offers__badge {
    padding: 6px 14px 6px 6px;
  }

  .bv-offers__badge-text {
    font-size: 0.72rem;
  }

  .bv-offers__item-text em {
    display: none;
  }
}

@media (max-width: 480px) {
  .bv-offers__badge-text {
    display: none;
  }

  .bv-offers__badge {
    padding: 6px;
  }
}

.bv-section--listings {
  background: var(--bv-bg-cream);
}

.bv-featured {
  padding-block: var(--bv-section-y);
  background: var(--bv-bg);
}

.bv-featured__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--bv-space-5);
  margin-bottom: var(--bv-space-7);
  flex-wrap: wrap;
}

.bv-featured__head-left {
  max-width: 720px;
}

.bv-featured__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--bv-font-display);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: var(--bv-primary-700);
  text-transform: uppercase;
  margin-bottom: 10px;
}

.bv-featured__eyebrow i {
  color: var(--bv-primary);
  font-size: 14px;
}

.bv-featured__title {
  margin: 0 0 12px;
}

.bv-featured__lede {
  color: var(--bv-muted);
  font-size: var(--bv-text-base);
  max-width: 620px;
  margin: 0;
  line-height: 1.6;
}

.bv-featured__view-all {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 11px 22px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid var(--bv-primary);
  color: var(--bv-primary-700);
  background: transparent;
  font-family: var(--bv-font-display);
  font-weight: 700;
  font-size: 0.92rem;
  text-decoration: none;
  transition:
    transform var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.bv-featured__view-all i {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--bv-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  transition: transform var(--bv-dur) var(--bv-ease);
}

.bv-featured__view-all:hover {
  background: var(--bv-primary);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: var(--bv-shadow-teal);
}

.bv-featured__view-all:hover i {
  background: #fff;
  color: var(--bv-primary);
  transform: translateX(3px);
}

.bv-featured__grid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
  gap: clamp(1rem, 2vw, 1.75rem);
  align-items: start;
}

.bv-featured__hero {
  display: flex;
  flex-direction: column;
}

.bv-featured__hero-card {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  isolation: isolate;
  background: var(--bv-ink);
  box-shadow:
    0 30px 60px -20px rgba(15, 23, 42, 0.28),
    0 0 0 1px rgba(255, 255, 255, 0.04);
  aspect-ratio: 4 / 3.4;
}

.bv-featured__hero-imgs {
  position: absolute;
  inset: 0;
}

.bv-featured__hero-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transform: scale(1.04);
  transition:
    opacity 0.55s var(--bv-ease-out),
    transform 0.8s var(--bv-ease-out);
}

.bv-featured__hero-img.is-active {
  opacity: 1;
  transform: scale(1);
}

.bv-featured__hero-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      180deg,
      rgba(15, 23, 42, 0) 25%,
      rgba(15, 23, 42, 0.45) 75%,
      rgba(15, 23, 42, 0.65) 100%
    ),
    linear-gradient(90deg, rgba(15, 23, 42, 0.2) 0%, transparent 35%);
  pointer-events: none;
}

.bv-featured__hero-badge {
  position: absolute;
  top: 18px;
  left: 18px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px 7px 12px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-ink);
  color: #fff;
  font-family: var(--bv-font-display);
  font-weight: 700;
  font-size: 0.78rem;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.3);
  z-index: 2;
}

.bv-featured__hero-badge i {
  color: #fbbf24;
  font-size: 12px;
}

.bv-featured__hero-arrow {
  position: absolute;
  top: 36%;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.96);
  color: var(--bv-ink);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.3);
  z-index: 4;
  border: none;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.bv-featured__hero-arrow--prev {
  left: 18px;
}

.bv-featured__hero-arrow--next {
  right: 18px;
}

.bv-featured__hero-arrow:hover {
  background: var(--bv-primary);
  color: #fff;
  transform: scale(1.05);
}

.bv-featured__hero-info {
  position: absolute;
  left: 18px;
  bottom: 157px;
  z-index: 3;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  padding: 16px 18px;
  border-radius: 16px;
  max-width: 320px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bv-featured__hero-info-loc {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--bv-muted);
  margin: 0;
}

.bv-featured__hero-info-loc i {
  color: var(--bv-primary);
  font-size: 11px;
}

.bv-featured__hero-info-title {
  font-family: var(--bv-font-display);
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.01em;
  margin: 0;
  line-height: 1.2;
}

.bv-featured__hero-info-desc {
  font-size: 0.78rem;
  color: var(--bv-muted);
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bv-featured__hero-info-btn {
  align-self: flex-start;
  margin-top: 6px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 6px 6px 16px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-grad-primary);
  color: #fff;
  font-family: var(--bv-font-display);
  font-weight: 700;
  font-size: 0.82rem;
  border: none;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.32);
  transition:
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.bv-featured__hero-info-btn span {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.bv-featured__hero-info-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(20, 184, 166, 0.45);
}

.bv-featured__gallery {
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 18px;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  padding: 6px;
  background: rgba(15, 23, 42, 0.36);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.bv-featured__gallery-thumb {
  position: relative;
  aspect-ratio: 16 / 11;
  border-radius: 9px;
  overflow: hidden;
  background: var(--bv-bg-soft);
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.bv-featured__gallery-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.75);
  transition:
    filter var(--bv-dur) var(--bv-ease),
    transform 0.6s var(--bv-ease-out);
}

.bv-featured__gallery-thumb:hover img {
  filter: brightness(1);
  transform: scale(1.06);
}

.bv-featured__gallery-thumb.is-active {
  border-color: #5eead4;
  box-shadow: 0 4px 14px rgba(94, 234, 212, 0.45);
}

.bv-featured__gallery-thumb.is-active img {
  filter: brightness(1.05);
}

.bv-featured__side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bv-featured__mini {
  position: relative;
  display: grid;
  grid-template-columns: 118px 1fr auto;
  align-items: stretch;
  gap: 12px;
  padding: 10px;
  border-radius: 18px;
  background: #fff;
  border: 1.5px solid var(--bv-line);
  text-align: left;
  font: inherit;
  color: inherit;
  transition:
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease);
}

.bv-featured__mini:hover {
  transform: translateY(-3px);
  box-shadow: var(--bv-shadow-card-hover);
  border-color: transparent;
}

.bv-featured__mini.is-active {
  border-color: var(--bv-primary);
  background: linear-gradient(180deg, #fff 0%, #f0fdfa 100%);
  box-shadow: 0 12px 28px -10px rgba(20, 184, 166, 0.45);
}

.bv-featured__mini.is-active::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  width: 4px;
  height: 36px;
  border-radius: 4px;
  background: var(--bv-primary);
  transform: translateY(-50%);
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.45);
}

.bv-featured__mini-overlay {
  position: absolute;
  inset: 0;
  background: transparent;
  border: none;
  border-radius: 18px;
  cursor: pointer;
  z-index: 1;
  padding: 0;
}

.bv-featured__mini-overlay:focus-visible {
  outline: 2px solid var(--bv-primary);
  outline-offset: 3px;
}

.bv-featured__mini-media,
.bv-featured__mini-body {
  position: relative;
  z-index: 0;
  pointer-events: none;
}

.bv-featured__mini-media {
  position: relative;
  width: 118px;
  height: 118px;
  border-radius: 14px;
  overflow: hidden;
  background: var(--bv-bg-soft);
  flex-shrink: 0;
}

.bv-featured__mini-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s var(--bv-ease-out);
}

.bv-featured__mini:hover .bv-featured__mini-media img {
  transform: scale(1.08);
}

.bv-featured__mini-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.96);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--bv-shadow-xs);
  padding: 4px;
}

.bv-featured__mini-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.bv-featured__mini-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  align-self: center;
}

.bv-featured__mini-body h3 {
  font-family: var(--bv-font-display);
  font-size: 1rem;
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.01em;
  margin: 0;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bv-featured__mini-loc {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: var(--bv-muted);
  font-weight: 500;
  margin: 0;
}

.bv-featured__mini-loc i {
  color: var(--bv-primary);
  font-size: 10px;
}

.bv-featured__mini-desc {
  font-size: 0.78rem;
  color: var(--bv-muted);
  margin: 0;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bv-featured__mini-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.bv-featured__mini-tags > span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px 3px 3px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid rgba(20, 184, 166, 0.18);
  color: var(--bv-primary-700);
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: capitalize;
  letter-spacing: 0;
}

.bv-featured__mini-tag-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  box-shadow: 0 1px 3px rgba(20, 184, 166, 0.18);
}

.bv-featured__mini-tag-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.bv-featured__mini-arrow {
  position: relative;
  z-index: 2;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--bv-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  align-self: center;
  flex-shrink: 0;
  transition:
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
  box-shadow: 0 6px 16px rgba(20, 184, 166, 0.32);
  text-decoration: none;
}

.bv-featured__mini-arrow:hover {
  color: #fff;
}

.bv-featured__mini:hover .bv-featured__mini-arrow {
  transform: translateX(3px) scale(1.05);
  box-shadow: 0 10px 22px rgba(20, 184, 166, 0.42);
}

.bv-featured__empty {
  text-align: center;
  padding: var(--bv-space-7);
  color: var(--bv-muted);
  font-style: italic;
}

@media (max-width: 1280px) {
  .bv-featured__hero-info {
    max-width: 360px;
    padding: 14px 16px;
  }

  .bv-featured__hero-info-title {
    font-size: 1.1rem;
  }
}

@media (max-width: 1100px) {
  .bv-featured__grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .bv-featured__hero-card {
    aspect-ratio: 16 / 10;
  }

  .bv-featured__hero-info {
    max-width: 380px;
  }

  .bv-featured__side {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    display: grid;
    gap: 14px;
  }
}

@media (max-width: 820px) {
  .bv-featured__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .bv-featured__hero-card {
    aspect-ratio: 4 / 3.6;
  }

  .bv-featured__hero-info {
    left: 14px;
    right: 14px;
    bottom: 96px;
    max-width: none;
    padding: 12px 14px;
  }

  .bv-featured__hero-info-title {
    font-size: 1rem;
  }

  .bv-featured__hero-info-desc {
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  .bv-featured__hero-arrow {
    width: 36px;
    height: 36px;
    top: 32%;
  }

  .bv-featured__gallery {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    left: 12px;
    right: 12px;
    bottom: 12px;
    padding: 5px;
    gap: 6px;
  }

  .bv-featured__side {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bv-featured__mini {
    grid-template-columns: 100px 1fr auto;
    gap: 12px;
    padding: 10px;
  }

  .bv-featured__mini-media {
    width: 100px;
    height: 100px;
  }

  .bv-featured__mini-body h3 {
    font-size: 0.92rem;
  }

  .bv-featured__mini-arrow {
    width: 36px;
    height: 36px;
    font-size: 12px;
  }
}

@media (max-width: 600px) {
  .bv-featured__hero-card {
    aspect-ratio: 4 / 4.4;
  }

  .bv-featured__side {
    grid-template-columns: 1fr;
  }

  .bv-featured__hero-info {
    left: 10px;
    right: 10px;
    bottom: 90px;
    max-width: none;
    padding: 10px 12px;
  }

  .bv-featured__hero-info-title {
    font-size: 0.95rem;
  }

  .bv-featured__hero-info-desc {
    -webkit-line-clamp: 2;
    line-clamp: 2;
    font-size: 0.72rem;
  }

  .bv-featured__gallery {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    left: 8px;
    right: 8px;
    bottom: 8px;
    gap: 4px;
    padding: 4px;
  }

  .bv-featured__mini {
    grid-template-columns: 90px 1fr 36px;
    gap: 10px;
    padding: 10px;
  }

  .bv-featured__mini-media {
    width: 90px;
    height: 90px;
  }

  .bv-featured__mini-body h3 {
    font-size: 0.88rem;
  }

  .bv-featured__mini-desc {
    -webkit-line-clamp: 2;
    line-clamp: 2;
  }

  .bv-featured__mini-tags {
    gap: 4px;
  }

  .bv-featured__mini-tags > span {
    padding: 2px 7px 2px 2px;
    font-size: 0.62rem;
  }

  .bv-featured__mini-tag-icon {
    width: 16px;
    height: 16px;
    padding: 2px;
  }
}

@media (max-width: 420px) {
  .bv-featured__hero-info-btn {
    padding: 5px 5px 5px 12px;
    font-size: 0.74rem;
  }

  .bv-featured__hero-info-btn span {
    width: 20px;
    height: 20px;
  }

  .bv-featured__hero-info {
    padding: 8px 10px;
  }
}

.bv-view-all-wrap {
  text-align: center;
  margin-top: var(--bv-space-9);
}

.bv-section--faq {
  background: #fff;
}

.bv-faq-wrap {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.2fr);
  gap: clamp(2rem, 4vw, 4rem);
  align-items: start;
}

.bv-faq-aside {
  position: sticky;
  top: 110px;
  padding: var(--bv-space-7);
  border-radius: var(--bv-radius-2xl);
  background: linear-gradient(160deg, var(--bv-primary-50) 0%, #ffffff 70%);
  border: 1px solid var(--bv-primary-line);
  overflow: hidden;
}

.bv-faq-aside .bv-section-eyebrow {
  background: #fff;
  margin-bottom: var(--bv-space-5);
}

.bv-faq-aside__title {
  margin-bottom: var(--bv-space-4);
}

.bv-faq-aside__lede {
  color: var(--bv-muted);
  font-size: var(--bv-text-base);
  line-height: 1.7;
  margin-bottom: var(--bv-space-6);
}

.bv-faq-aside__btn {
  background: #fff;
}

.bv-faq-aside__deco {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bv-faq-aside__ball {
  position: absolute;
  opacity: 0.85;
  filter: drop-shadow(0 8px 18px rgba(15, 23, 42, 0.12));
}

.bv-faq-aside__ball--1 {
  width: 70px;
  top: -10px;
  right: 12px;
  animation: bvFloat 5s ease-in-out infinite;
}

.bv-faq-aside__ball--2 {
  width: 50px;
  bottom: 24px;
  right: 60px;
  animation: bvFloat 6s ease-in-out infinite 0.6s;
}

.bv-faq-aside__ball--3 {
  width: 56px;
  top: 56%;
  right: -16px;
  animation: bvFloat 5.5s ease-in-out infinite 1s;
}

.bv-faq-aside > * {
  position: relative;
  z-index: 1;
}

.bv-faq-list {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-4);
}

.bv-faq-item {
  background: #fff;
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-xl);
  overflow: hidden;
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.bv-faq-item:hover {
  border-color: var(--bv-primary-line);
  box-shadow: var(--bv-shadow);
  transform: translateY(-2px);
}

.bv-faq-item.is-open {
  border-color: var(--bv-primary);
  box-shadow:
    0 0 0 4px rgba(20, 184, 166, 0.1),
    var(--bv-shadow);
}

.bv-faq-item__btn {
  width: 100%;
  display: grid;
  grid-template-columns: 44px 1fr 36px;
  align-items: center;
  gap: 16px;
  background: transparent;
  border: none;
  padding: 14px 16px;
  text-align: left;
  cursor: pointer;
}

.bv-faq-item__num {
  width: 44px;
  height: 44px;
  border-radius: var(--bv-radius);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--bv-font-display);
  font-weight: 800;
  font-size: var(--bv-text-base);
  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.bv-faq-item.is-open .bv-faq-item__num {
  background: var(--bv-grad-primary);
  color: #fff;
}

.bv-faq-item__q {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-base);
  font-weight: 600;
  color: var(--bv-ink);
  line-height: 1.4;
}

.bv-faq-item__chev {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--bv-bg-soft);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--bv-ink-2);
  transition:
    transform var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}

.bv-faq-item.is-open .bv-faq-item__chev {
  background: var(--bv-primary);
  color: #fff;
  transform: rotate(180deg);
}

.bv-faq-item__body {
  overflow: hidden;
  max-height: 0;
  transition: max-height var(--bv-dur-slow) var(--bv-ease-out);
}

.bv-faq-item.is-open .bv-faq-item__body {
  max-height: 360px;
}

.bv-faq-item__body-inner {
  padding: 0 16px 16px 72px;
  color: var(--bv-muted);
  font-size: var(--bv-text-sm);
  line-height: 1.7;
}

@media (max-width: 992px) {
  .bv-faq-wrap {
    grid-template-columns: 1fr;
  }

  .bv-faq-aside {
    position: static;
  }

  .bv-faq-item__body-inner {
    padding-left: 16px;
  }
}

.slick-prev,
.slick-next {
  width: 44px !important;
  height: 44px !important;
  background: #fff !important;
  border-radius: 50% !important;
  box-shadow: var(--bv-shadow) !important;
  border: 1px solid var(--bv-line) !important;
  z-index: 5 !important;
  transition: all var(--bv-dur) var(--bv-ease) !important;
}

.slick-prev:hover,
.slick-next:hover {
  background: var(--bv-grad-primary) !important;
  border-color: transparent !important;
  transform: scale(1.06);
}

.slick-prev::before,
.slick-next::before {
  font-family:
    "Font Awesome 6 Free", "Font Awesome 5 Free", sans-serif !important;
  font-weight: 900 !important;
  color: var(--bv-ink) !important;
  opacity: 1 !important;
  font-size: 14px !important;
  transition: color var(--bv-dur) var(--bv-ease) !important;
}

.slick-prev::before {
  content: "\\f060" !important;
}

.slick-next::before {
  content: "\\f061" !important;
}

.slick-prev:hover::before,
.slick-next:hover::before {
  color: #fff !important;
}

.slick-prev {
  left: -8px !important;
}

.slick-next {
  right: -8px !important;
}

.slick-list {
  margin: 0 -8px !important;
  padding: 8px 0 !important;
}

.slick-slide > div {
  padding: 0 8px;
}

@media (max-width: 768px) {
  .slick-prev,
  .slick-next {
    width: 38px !important;
    height: 38px !important;
  }

  .slick-prev {
    left: -4px !important;
  }

  .slick-next {
    right: -4px !important;
  }
}

/* ---- Right sticky back-to-top FAB ---- */
.bv-back-top {
  position: fixed;
  right: clamp(1rem, 2.4vw, 1.75rem);
  top: 50%;
  z-index: 45;
  width: 52px;
  height: 52px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%) translateX(calc(100% + 20px)) scale(0.88);
  transition:
    transform var(--bv-dur-slow) var(--bv-ease-out),
    opacity var(--bv-dur) var(--bv-ease);
}

.bv-back-top.is-visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(-50%) translateX(0) scale(1);
}

.bv-back-top:focus-visible {
  outline: none;
}

.bv-back-top:focus-visible .bv-back-top__icon {
  box-shadow:
    0 0 0 3px rgba(20, 184, 166, 0.28),
    var(--bv-shadow-teal);
}

.bv-back-top__ring {
  position: absolute;
  inset: 0;
  filter: drop-shadow(0 4px 12px rgba(15, 23, 42, 0.08));
  transition: filter var(--bv-dur) var(--bv-ease);
}

.bv-back-top:hover .bv-back-top__ring,
.bv-back-top:focus-visible .bv-back-top__ring {
  filter: drop-shadow(0 8px 20px rgba(20, 184, 166, 0.28));
}

.bv-back-top__ring svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.bv-back-top__ring-track {
  fill: none;
  stroke: rgba(226, 232, 240, 0.95);
  stroke-width: 3;
}

.bv-back-top__ring-fill {
  fill: none;
  stroke: url(#bvBackTopGrad);
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dashoffset var(--bv-dur-fast) var(--bv-ease);
}

.bv-back-top__icon {
  position: absolute;
  inset: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid var(--bv-primary-line);
  box-shadow: var(--bv-shadow-sm);
  color: var(--bv-primary-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease-spring);
}

.bv-back-top:hover .bv-back-top__icon,
.bv-back-top:focus-visible .bv-back-top__icon {
  background: var(--bv-grad-primary);
  border-color: transparent;
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .bv-back-top {
    top: auto;
    bottom: calc(92px + env(safe-area-inset-bottom, 0px));
    width: 48px;
    height: 48px;
    transform: translateY(0) translateX(calc(100% + 20px)) scale(0.88);
  }

  .bv-back-top.is-visible {
    transform: translateY(0) translateX(0) scale(1);
  }

  .bv-back-top__icon {
    inset: 5px;
    font-size: 0.88rem;
  }
}

/* ---- Sticky WhatsApp chat (homepage) ---- */
.bv-wa-chat {
  position: fixed;
  right: clamp(1rem, 2.4vw, 1.75rem);
  left: auto;
  bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));
  z-index: 44;
  isolation: isolate;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 8px 8px;
  border-radius: var(--bv-radius-pill, 999px);
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(37, 211, 102, 0.22);
  color: #15803d;
  text-decoration: none;
  font-family: var(--bv-font-display, inherit);
  font-size: var(--bv-text-sm, 0.875rem);
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
  box-shadow:
    0 4px 18px rgba(15, 23, 42, 0.07),
    0 1px 3px rgba(37, 211, 102, 0.1);
  transition:
    transform var(--bv-dur, 280ms)
      var(--bv-ease-spring, cubic-bezier(0.34, 1.4, 0.64, 1)),
    box-shadow var(--bv-dur, 280ms) var(--bv-ease, ease),
    border-color var(--bv-dur, 280ms) var(--bv-ease, ease),
    background var(--bv-dur, 280ms) var(--bv-ease, ease);
  animation: bvWaChatIn 0.5s var(--bv-ease-out, ease) 0.5s both;
}

.bv-wa-chat:hover,
.bv-wa-chat:focus-visible {
  color: #166534;
  background: #fff;
  border-color: rgba(37, 211, 102, 0.38);
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(15, 23, 42, 0.09),
    0 2px 8px rgba(37, 211, 102, 0.14);
}

.bv-wa-chat:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 3px rgba(37, 211, 102, 0.18),
    0 8px 24px rgba(15, 23, 42, 0.09);
}

.bv-wa-chat__pulse {
  position: absolute;
  inset: -2px;
  border-radius: inherit;
  border: 1px solid rgba(37, 211, 102, 0.28);
  animation: bvWaPulse 3s ease-out infinite;
  z-index: -1;
  pointer-events: none;
}

.bv-wa-chat__icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(145deg, #34d399 0%, #25d366 100%);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.28);
}

.bv-wa-chat__label {
  padding-right: 4px;
  white-space: nowrap;
  opacity: 0.92;
}

@keyframes bvWaPulse {
  0% {
    transform: scale(1);
    opacity: 0.45;
  }

  70% {
    transform: scale(1.1);
    opacity: 0;
  }

  100% {
    transform: scale(1.1);
    opacity: 0;
  }
}

@keyframes bvWaChatIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .bv-wa-chat {
    right: clamp(0.75rem, 3vw, 1rem);
    bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
    padding: 7px 14px 7px 7px;
    gap: 7px;
  }

  .bv-wa-chat__icon {
    width: 30px;
    height: 30px;
    font-size: 1rem;
  }
}

@media (max-width: 380px) {
  .bv-wa-chat__label {
    font-size: var(--bv-text-xs, 0.75rem);
  }
}

.section {
  padding-block: var(--bv-section-y);
}

.section-heading {
  text-align: center;
  margin: 0 0 var(--bv-space-9);
}

.section-heading h2 {
  margin: 0 0 var(--bv-space-3);
}

.section-heading p,
.sub-title {
  color: var(--bv-muted);
  max-width: 640px;
  margin: 0 auto;
  font-size: var(--bv-text-lg);
}
/* =========================================================
   SPOTLIGHT — SAME BROCODE LIGHT / TEAL THEME
   ========================================================= */

.spotlight-layout {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(250px, 0.78fr) minmax(0, 1.45fr);
  gap: clamp(1rem, 2vw, 1.75rem);
  align-items: stretch;
  color: var(--bv-ink);
}

/* =========================================================
   LEFT VENUE LIST
   ========================================================= */

.spotlight-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

/* VENUE ITEM */

.spotlight-item {
  appearance: none;
  -webkit-appearance: none;

  position: relative;

  width: 100%;
  min-height: 78px;

  display: flex;
  align-items: center;
  gap: 14px;

  padding: 14px 16px;

  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-md, 16px);

  background: #fff;
  color: var(--bv-ink);

  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.055);

  cursor: pointer;
  text-align: left;

  transition:
    transform var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.spotlight-item:hover {
  transform: translateX(5px);

  border-color: rgba(20, 184, 166, 0.35);

  background: #f8fffd;

  box-shadow: 0 10px 28px rgba(20, 184, 166, 0.1);
}

/* ACTIVE */

.spotlight-item--active {
  background: linear-gradient(
    135deg,
    var(--bv-primary-50, #f0fdfa) 0%,
    #ffffff 100%
  );

  border-color: rgba(20, 184, 166, 0.45);

  box-shadow:
    0 12px 30px rgba(20, 184, 166, 0.12),
    inset 3px 0 0 var(--bv-primary);

  transform: translateX(5px);
}

/* =========================================================
   NUMBER
   ========================================================= */

.spotlight-item__number {
  flex: 0 0 auto;

  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background: var(--bv-bg-cream);

  color: var(--bv-primary-700);

  font-family: var(--bv-font-display);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.spotlight-item--active .spotlight-item__number {
  background: var(--bv-grad-primary);
  color: #fff;

  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.25);
}

/* =========================================================
   CONTENT
   ========================================================= */

.spotlight-item__content {
  min-width: 0;
  flex: 1 1;

  display: flex;
  flex-direction: column;
  gap: 5px;
}

.spotlight-item__name {
  display: block;

  margin: 0;

  color: var(--bv-ink);

  font-family: var(--bv-font-display);

  font-size: 0.98rem;
  line-height: 1.25;
  font-weight: 800;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.spotlight-item--active .spotlight-item__name {
  color: var(--bv-primary-700);
}

.spotlight-item__location {
  display: flex;
  align-items: center;
  gap: 6px;

  margin: 0;

  color: var(--bv-muted);

  font-size: 0.72rem;
  line-height: 1.3;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.spotlight-item__location i {
  flex-shrink: 0;
  color: var(--bv-primary);
}

/* =========================================================
   ITEM ARROW
   ========================================================= */

.spotlight-item__arrow {
  flex: 0 0 32px;

  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: var(--bv-primary-50, #f0fdfa);

  color: var(--bv-primary-700);

  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.spotlight-item:hover .spotlight-item__arrow,
.spotlight-item--active .spotlight-item__arrow {
  background: var(--bv-grad-primary);
  color: #fff;

  transform: translateX(2px);

  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.25);
}

/* =========================================================
   RIGHT HERO
   ========================================================= */

.spotlight-hero {
  width: 100%;
  min-width: 0;
}

.spotlight-hero__card {
  position: relative;

  width: 100%;
  min-height: 540px;

  overflow: hidden;
  isolation: isolate;

  border-radius: 24px;

  background: var(--bv-ink);

  box-shadow:
    0 30px 60px -20px rgba(15, 23, 42, 0.28),
    0 0 0 1px rgba(255, 255, 255, 0.05);
}

/* =========================================================
   HERO IMAGE
   ========================================================= */

.spotlight-hero__images {
  position: absolute;
  inset: 0;

  width: 100%;
  height: 100%;
}

.spotlight-hero__image {
  position: absolute;
  inset: 0;

  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  opacity: 0;

  transform: scale(1.04);

  transition:
    opacity 0.55s var(--bv-ease-out),
    transform 0.8s var(--bv-ease-out);
}

.spotlight-hero__image--active {
  opacity: 1;
  transform: scale(1);
}

/* =========================================================
   HERO OVERLAY
   ========================================================= */

.spotlight-hero__overlay {
  position: absolute;
  inset: 0;

  z-index: 2;

  pointer-events: none;

  background:
    linear-gradient(
      180deg,
      rgba(15, 23, 42, 0.02) 20%,
      rgba(15, 23, 42, 0.16) 48%,
      rgba(15, 23, 42, 0.72) 100%
    ),
    linear-gradient(90deg, rgba(15, 23, 42, 0.12), transparent 45%);
}

/* =========================================================
   POPULAR BADGE
   ========================================================= */

.spotlight-hero__badge {
  position: absolute;

  top: 20px;
  left: 20px;

  z-index: 5;

  display: inline-flex;
  align-items: center;
  gap: 7px;

  padding: 8px 13px;

  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: var(--bv-radius-pill, 999px);

  background: rgba(255, 255, 255, 0.88);

  color: var(--bv-primary-700);

  font-family: var(--bv-font-display);

  font-size: 0.72rem;
  font-weight: 800;

  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.spotlight-hero__badge i {
  color: #f59e0b;
}

/* =========================================================
   HERO NAVIGATION
   ========================================================= */

.spotlight-hero__navigation {
  position: absolute;

  top: 20px;
  right: 20px;

  z-index: 5;

  display: flex;
  gap: 8px;
}

.spotlight-hero__navigation button {
  appearance: none;
  -webkit-appearance: none;

  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;

  background: rgba(255, 255, 255, 0.88);

  color: var(--bv-primary-700);

  cursor: pointer;

  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.spotlight-hero__navigation button:hover {
  background: var(--bv-grad-primary);
  color: #fff;

  transform: translateY(-2px);
}

/* =========================================================
   HERO INFORMATION
   ========================================================= */

.spotlight-hero__info {
  position: absolute;
  left: 18px;
  bottom: 40px;
  z-index: 3;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  padding: 16px 18px;
  border-radius: 16px;
  max-width: 320px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.spotlight-hero__location {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--bv-muted);
  margin: 0;
}

.spotlight-hero__location i {
  color: #5eead4;
}

.spotlight-hero__title {
  font-family: var(--bv-font-display);
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.01em;
  margin: 0;
  line-height: 1.2;
}

.spotlight-hero__description {
  max-width: 570px;

  margin: 0 0 0px;

  color: #64748b;

  font-size: 0.82rem;
  line-height: 1.6;
}

/* =========================================================
   BOOK BUTTON
   ========================================================= */

.spotlight-hero__button {
  appearance: none;
  -webkit-appearance: none;

  display: inline-flex;
  align-items: center;

  gap: 12px;

  padding: 7px 8px 7px 18px;

  border: 0;
  border-radius: var(--bv-radius-pill, 999px);

  background: var(--bv-grad-primary);
  color: #fff;

  font-family: var(--bv-font-display);

  font-size: 0.82rem;
  font-weight: 800;

  cursor: pointer;

  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.3);

  transition:
    transform var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease);
}

.spotlight-hero__button:hover {
  transform: translateY(-2px);

  box-shadow: 0 12px 26px rgba(20, 184, 166, 0.38);
}

.spotlight-hero__button span {
  width: 31px;
  height: 31px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: rgba(255, 255, 255, 0.2);

  color: #fff;
}

/* =========================================================
   GALLERY
   ========================================================= */

.spotlight-gallery {
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 18px;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  padding: 6px;
  background: rgba(15, 23, 42, 0.36);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.spotlight-gallery__thumb {
  appearance: none;
  -webkit-appearance: none;

  width: 54px;
  height: 40px;

  padding: 0;

  overflow: hidden;

  border: 2px solid transparent;
  border-radius: 8px;

  background: rgba(255, 255, 255, 0.35);

  opacity: 0.7;

  cursor: pointer;

  transition:
    opacity var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease);
}

.spotlight-gallery__thumb img {
  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;
}

.spotlight-gallery__thumb:hover {
  opacity: 1;
  transform: translateY(-2px);
}

.spotlight-gallery__thumb--active {
  opacity: 1;

  border-color: #fff;

  box-shadow: 0 0 0 2px var(--bv-primary);
}

/* =========================================================
   EMPTY
   ========================================================= */

.spotlight-empty {
  padding: 50px;

  color: var(--bv-muted);

  text-align: center;
}

/* =========================================================
   RESPONSIVE
   ========================================================= */

@media (max-width: 1100px) {
  .spotlight-layout {
    grid-template-columns: minmax(220px, 0.8fr) minmax(0, 1.2fr);
    gap: 18px;
  }

  .spotlight-hero__card {
    min-height: 480px;
  }

  .spotlight-hero__info {
    left: 24px;
    right: 24px;
    bottom: 24px;
  }
}

@media (max-width: 768px) {
  .spotlight-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .spotlight-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .spotlight-item {
    min-height: 70px;
    padding: 12px;
  }

  .spotlight-item__number {
    width: 30px;
    height: 30px;
  }

  .spotlight-hero__card {
    min-height: 430px;
    border-radius: 20px;
  }

  .spotlight-gallery {
    display: none;
  }
}

@media (max-width: 480px) {
  .spotlight-list {
    grid-template-columns: 1fr;
  }

  .spotlight-hero__card {
    min-height: 400px;
  }

  .spotlight-hero__info {
    left: 18px;
    right: 18px;
    bottom: 18px;
  }

  .spotlight-hero__title {
    font-size: 1.75rem;
  }

  .spotlight-hero__description {
    font-size: 0.75rem;
  }

  .spotlight-hero__badge {
    top: 14px;
    left: 14px;
  }

  .spotlight-hero__navigation {
    top: 14px;
    right: 14px;
  }
}
.bv-featured--hotels .bv-featured__grid {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr);
}

.bv-featured--hotels .bv-featured__side {
  grid-column: 1;
  grid-row: 1;
}

.bv-featured--hotels .bv-featured__hero {
  grid-column: 2;
  grid-row: 1;
}
.bv-featured__hero-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 8;
  transition: all 0.25s ease;
}

.bv-featured__hero-arrow:hover {
  background: #0f766e;
  border-color: #0f766e;
  transform: translateY(-50%) scale(1.06);
}

.bv-featured__hero-arrow--prev {
  left: 20px;
}

.bv-featured__hero-arrow--next {
  right: 20px;
}

.bv-featured__gallery {
  position: absolute;
  left: 24px;
  right: 24px;
  bottom: 20px;
  z-index: 10;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
}

.bv-featured__gallery::-webkit-scrollbar {
  display: none;
}

.bv-featured__gallery-thumb {
  flex: 0 0 58px;
  width: 58px;
  height: 46px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 9px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.3);
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.25s ease;
}

.bv-featured__gallery-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.bv-featured__gallery-thumb:hover {
  opacity: 1;
  transform: translateY(-2px);
}

.bv-featured__gallery-thumb.is-active {
  opacity: 1;
  border-color: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}
.bv-stage__tag-icon--hotel {
  background: rgba(20, 184, 166, 0.14);
  color: #0d9488;
}

/* =========================================================
   FEATURED HOTELS — RESPONSIVE FIXES
   Paste at the END of your stylesheet (after the
   .bv-featured--hotels overrides).
   ========================================================= */

/* ---- Price / rating row (replaces inline styles) ---- */
.bv-featured__hero-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin: 2px 0 4px;
}

.bv-featured__hero-price {
  font-family: var(--bv-font-display);
  font-size: 1rem;
  font-weight: 800;
  color: var(--bv-ink);
}

.bv-featured__hero-price small {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--bv-muted);
}

.bv-featured__hero-rating {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--bv-ink);
}

.bv-featured__hero-rating i {
  color: #fbbf24;
}

/* ---- Mini card price (now in normal flow, not absolute) ---- */
.bv-featured__mini-price {
  margin: 6px 0 0;
  font-family: var(--bv-font-display);
  font-size: 0.85rem;
  font-weight: 800;
  color: var(--bv-primary-700);
}

.bv-featured__mini-price small {
  font-weight: 500;
  color: var(--bv-muted);
}

/* =========================================================
   TABLET (≤1100px): single column, hero on top
   ========================================================= */
@media (max-width: 1100px) {
  .bv-featured--hotels .bv-featured__grid {
    grid-template-columns: minmax(0, 1fr);
  }

  /* KEY FIX: reset the desktop column placement */
  .bv-featured--hotels .bv-featured__hero,
  .bv-featured--hotels .bv-featured__side {
    grid-column: auto;
    grid-row: auto;
  }

  .bv-featured--hotels .bv-featured__hero {
    order: 1;
  }

  .bv-featured--hotels .bv-featured__side {
    order: 2;
  }

  .bv-featured--hotels .bv-featured__hero-info {
    bottom: 90px;
  }
}

/* =========================================================
   MOBILE (≤820px)
   ========================================================= */
@media (max-width: 820px) {
  .bv-featured--hotels .bv-featured__side {
    grid-template-columns: minmax(0, 1fr);
  }

  /* Taller card so the info panel doesn't collide with badge/arrows */
  .bv-featured--hotels .bv-featured__hero-card {
    aspect-ratio: auto;
    height: clamp(440px, 120vw, 560px);
  }

  .bv-featured--hotels .bv-featured__hero-badge {
    top: 12px;
    left: 12px;
  }

  .bv-featured--hotels .bv-featured__hero-arrow {
    top: 32%;
    width: 36px;
    height: 36px;
  }

  .bv-featured--hotels .bv-featured__hero-arrow--prev {
    left: 12px;
  }

  .bv-featured--hotels .bv-featured__hero-arrow--next {
    right: 12px;
  }

  .bv-featured--hotels .bv-featured__hero-info {
    left: 12px;
    right: 12px;
    bottom: 76px;
    max-width: none;
    padding: 12px 14px;
  }

  .bv-featured--hotels .bv-featured__gallery {
    left: 12px;
    right: 12px;
    bottom: 12px;
  }

  .bv-featured--hotels .bv-featured__gallery-thumb {
    flex: 0 0 52px;
    width: 52px;
    height: 40px;
  }

  .bv-featured--hotels .bv-featured__mini.is-active::before {
    left: -6px;
  }
}

/* =========================================================
   SMALL PHONES (≤480px)
   ========================================================= */
@media (max-width: 480px) {
  .bv-featured--hotels .bv-featured__hero-card {
    height: clamp(420px, 125vw, 500px);
    border-radius: 20px;
  }

  .bv-featured--hotels .bv-featured__hero-info {
    left: 10px;
    right: 10px;
    bottom: 62px;
    padding: 10px 12px;
    gap: 4px;
  }

  .bv-featured--hotels .bv-featured__hero-info-title {
    font-size: 1rem;
  }

  .bv-featured--hotels .bv-featured__hero-info-desc {
    font-size: 0.72rem;
  }

  .bv-featured--hotels .bv-featured__gallery {
    left: 10px;
    right: 10px;
    bottom: 10px;
    gap: 6px;
  }

  .bv-featured--hotels .bv-featured__gallery-thumb {
    flex: 0 0 44px;
    width: 44px;
    height: 34px;
    border-radius: 7px;
  }

  /* Mini cards: drop the arrow column to give text room */
  .bv-featured--hotels .bv-featured__mini {
    grid-template-columns: 84px minmax(0, 1fr);
    gap: 10px;
    padding: 10px;
  }

  .bv-featured--hotels .bv-featured__mini-media {
    width: 84px;
    height: 84px;
    border-radius: 12px;
  }

  .bv-featured--hotels .bv-featured__mini-arrow {
    display: none;
  }

  .bv-featured--hotels .bv-featured__mini-desc {
    -webkit-line-clamp: 1;
    line-clamp: 1;
  }
}
/* Desktop price (replaces the old inline style) */
.bv-featured__mini-price-abs {
  position: absolute;
  right: 55px;
  bottom: 18px;
  font-weight: 700;
  color: #0f766e;
  z-index: 3;
}

/* Mobile row hidden on desktop */
.bv-featured__mini-mobile {
  display: none;
}

/* =========================================================
   MOBILE: Stay → Price → Arrow only
   ========================================================= */
@media (max-width: 820px) {
  .bv-featured--hotels .bv-featured__mini {
    grid-template-columns: 84px minmax(0, 1fr);
    gap: 12px;
    padding: 10px;
    align-items: center;
  }

  .bv-featured--hotels .bv-featured__mini-media {
    width: 84px;
    height: 84px;
    border-radius: 12px;
  }

  /* hide desktop-only bits */
  .bv-featured--hotels .bv-featured__mini-desc,
  .bv-featured--hotels .bv-featured__mini-tags,
  .bv-featured--hotels .bv-featured__mini-arrow,
  .bv-featured--hotels .bv-featured__mini-price-abs {
    display: none;
  }

  /* let the arrow link sit above the click overlay */
  .bv-featured--hotels .bv-featured__mini-body {
    z-index: auto;
  }

  .bv-featured--hotels .bv-featured__mini-mobile {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
    position: relative;
    z-index: 2;
    pointer-events: none; /* clicks pass through to overlay… */
  }

  .bv-featured__mini-stay {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: var(--bv-radius-pill);
    background: var(--bv-primary-50);
    border: 1px solid rgba(20, 184, 166, 0.18);
    color: var(--bv-primary-700);
    font-size: 0.7rem;
    font-weight: 700;
    flex-shrink: 0;
  }

  .bv-featured__mini-stay i {
    font-size: 0.7rem;
  }

  .bv-featured__mini-mprice {
    font-family: var(--bv-font-display);
    font-size: 0.9rem;
    font-weight: 800;
    color: var(--bv-primary-700);
    white-space: nowrap;
  }

  .bv-featured__mini-mprice small {
    font-size: 0.68rem;
    font-weight: 500;
    color: var(--bv-muted);
    margin-left: 2px;
  }

  .bv-featured__mini-go {
    pointer-events: auto; /* …except the arrow */
    margin-left: auto;
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    background: var(--bv-grad-primary);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-decoration: none;
    box-shadow: 0 6px 16px rgba(20, 184, 166, 0.32);
    transition: transform var(--bv-dur) var(--bv-ease);
  }

  .bv-featured__mini-go:hover,
  .bv-featured__mini-go:active {
    color: #fff;
    transform: translateX(3px);
  }
}
/* Arrow hamesha overlay ke upar aur clickable rahe */
.bv-featured__mini-arrow,
.bv-featured__mini-go {
  position: relative;
  z-index: 5 !important;
  pointer-events: auto !important;
  border: none;
  cursor: pointer;
}

@media (max-width: 820px) {
  .bv-featured--hotels .bv-featured__mini-body {
    z-index: auto !important;
    pointer-events: none;
  }

  .bv-featured--hotels .bv-featured__mini-mobile {
    z-index: 5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/homepage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB;;;;;;;;;;;gBAWc;EACd,uDAAuD;AACzD;;AAEA;EACE,wEAAwE;EACxE,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,OAAO;EACP,SAAS;EACT,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;EACpC,wCAAwC;EACxC,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,4BAA4B;EAC5B;;2CAEyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B;;uBAEqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,gCAAgC;EAChC,yCAAyC;EACzC,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,iCAAiC;EACjC,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC;;mDAEiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,QAAQ;EACR,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,OAAO;EACP,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,QAAQ;EACR,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,0CAA0C;EAC1C,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB;;;;2CAIyC;EACzC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;EACX,gDAAgD;AAClD;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,SAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;IAGE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,oCAAoC;EACtC;;EAEA;IACE,oBAAoB;EACtB;;EAEA,mEAAmE;EACnE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,yEAAyE;IACzE,+CAA+C;EACjD;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,OAAO;IACP,QAAQ;IACR,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,OAAO;IACP,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,OAAO;EACT;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;IACX,OAAO;EACT;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,4DAA4D;EAC5D,0CAA0C;EAC1C,+CAA+C;EAC/C,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;EAC3C,+CAA+C;EAC/C,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB;;;;GAIC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EAQZ;;;;;;GAMC;AACH;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,MAAM;EACN,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,4BAA4B;EAC5B,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB;;;;2CAIyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB;;uCAEqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB;;qCAEmC;AACrC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;;;qEAOmE;EACnE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,UAAU;EACV,YAAY;EACZ,eAAe;EACf;;;0CAGwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,UAAU;EACV,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oCAAoC;EACpC,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,+CAA+C;EAC/C;;2CAEyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV;;;2CAGyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd;;;;2CAIyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0DAA0D;EAC1D,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;EAChC,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd;;2CAEyC;EACzC,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gDAAgD;IAChD,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,gDAAgD;IAChD,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gDAAgD;IAChD,SAAS;IACT,UAAU;IACV,WAAW;IACX,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,mCAAmC;EACnC,yEAAyE;EACzE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,gBAAgB;EAChB;;;0CAGwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B;;oBAEkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B;;sCAEoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB;;;sCAGoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,uCAAuC;EACvC,2CAA2C;EAC3C,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;;EAEE,6CAA6C;EAC7C,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE;uEACqE;EACrE,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;EACrB,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,kCAAkC;EAClC,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,qEAAqE;EACrE;;wCAEsC;AACxC;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;yBAEuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sDAAsD;EACtD,+CAA+C;AACjD;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;;;;iDAK+C;AACjD;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;EACzB,WAAW;EACX,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE;IACE,SAAS;IACT,qDAAqD;IACrD,WAAW;IACX,YAAY;IACZ,kEAAkE;EACpE;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,kCAAkC;EAClC,UAAU;EACV,uDAAuD;EACvD,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,2CAA2C;EAC3C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;EACd,qBAAqB;EACrB,4CAA4C;EAC5C,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd;;qCAEmC;EACnC;;;;;wDAKsD;EACtD,6DAA6D;AAC/D;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,2BAA2B;EAC3B;;sCAEoC;AACtC;;AAEA;EACE,aAAa;EACb;;qCAEmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,0CAA0C;EAC1C,yCAAyC;EACzC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,qDAAqD;IACrD,yBAAyB;IACzB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;AACA;;8DAE8D;;AAE9D;EACE,WAAW;EACX,aAAa;EACb,8DAA8D;EAC9D,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;8DAE8D;;AAE9D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA,eAAe;;AAEf;EACE,gBAAgB;EAChB,wBAAwB;;EAExB,kBAAkB;;EAElB,WAAW;EACX,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;;EAElB,gCAAgC;EAChC,wCAAwC;;EAExC,gBAAgB;EAChB,oBAAoB;;EAEpB,8CAA8C;;EAE9C,eAAe;EACf,gBAAgB;;EAEhB;;;;2CAIyC;AAC3C;;AAEA;EACE,0BAA0B;;EAE1B,sCAAsC;;EAEtC,mBAAmB;;EAEnB,+CAA+C;AACjD;;AAEA,WAAW;;AAEX;EACE;;;;GAIC;;EAED,sCAAsC;;EAEtC;;mCAEiC;;EAEjC,0BAA0B;AAC5B;;AAEA;;8DAE8D;;AAE9D;EACE,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,8BAA8B;;EAE9B,4BAA4B;;EAE5B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,WAAW;;EAEX,+CAA+C;AACjD;;AAEA;;8DAE8D;;AAE9D;EACE,YAAY;EACZ,SAAO;;EAEP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;;EAEd,SAAS;;EAET,oBAAoB;;EAEpB,mCAAmC;;EAEnC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;;EAEhB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,SAAS;;EAET,sBAAsB;;EAEtB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;8DAE8D;;AAE9D;EACE,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,yCAAyC;;EAEzC,4BAA4B;;EAE5B;;;0CAGwC;AAC1C;;AAEA;;EAEE,kCAAkC;EAClC,WAAW;;EAEX,0BAA0B;;EAE1B,+CAA+C;AACjD;;AAEA;;8DAE8D;;AAE9D;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,iBAAiB;;EAEjB,gBAAgB;EAChB,kBAAkB;;EAElB,mBAAmB;;EAEnB,yBAAyB;;EAEzB;;uCAEqC;AACvC;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,QAAQ;;EAER,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,iBAAiB;;EAEjB,UAAU;;EAEV,sBAAsB;;EAEtB;;qCAEmC;AACrC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,QAAQ;;EAER,UAAU;;EAEV,oBAAoB;;EAEpB;;;;;;;mEAOiE;AACnE;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;;EAElB,SAAS;EACT,UAAU;;EAEV,UAAU;;EAEV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;;EAER,iBAAiB;;EAEjB,2CAA2C;EAC3C,2CAA2C;;EAE3C,qCAAqC;;EAErC,4BAA4B;;EAE5B,mCAAmC;;EAEnC,kBAAkB;EAClB,gBAAgB;;EAEhB,6CAA6C;;EAE7C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;;EAElB,SAAS;EACT,WAAW;;EAEX,UAAU;;EAEV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;;EAExB,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,UAAU;;EAEV,0CAA0C;EAC1C,kBAAkB;;EAElB,qCAAqC;;EAErC,4BAA4B;;EAE5B,eAAe;;EAEf,6CAA6C;;EAE7C,2BAA2B;EAC3B,mCAAmC;;EAEnC;;;0CAGwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,WAAW;;EAEX,2BAA2B;AAC7B;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;;EAEf,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;8DAE8D;;AAE9D;EACE,gBAAgB;EAChB,wBAAwB;;EAExB,oBAAoB;EACpB,mBAAmB;;EAEnB,SAAS;;EAET,yBAAyB;;EAEzB,SAAS;EACT,2CAA2C;;EAE3C,kCAAkC;EAClC,WAAW;;EAEX,mCAAmC;;EAEnC,kBAAkB;EAClB,gBAAgB;;EAEhB,eAAe;;EAEf,8CAA8C;;EAE9C;;2CAEyC;AAC3C;;AAEA;EACE,2BAA2B;;EAE3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,oCAAoC;;EAEpC,WAAW;AACb;;AAEA;;8DAE8D;;AAE9D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;;EAExB,WAAW;EACX,YAAY;;EAEZ,UAAU;;EAEV,gBAAgB;;EAEhB,6BAA6B;EAC7B,kBAAkB;;EAElB,qCAAqC;;EAErC,YAAY;;EAEZ,eAAe;;EAEf;;;0CAGwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;;EAEV,kBAAkB;;EAElB,uCAAuC;AACzC;;AAEA;;8DAE8D;;AAE9D;EACE,aAAa;;EAEb,sBAAsB;;EAEtB,kBAAkB;AACpB;;AAEA;;8DAE8D;;AAE9D;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;;8DAI8D;;AAE9D,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;8DAE8D;AAC9D;EACE;IACE,qCAAqC;EACvC;;EAEA,gDAAgD;EAChD;;IAEE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;8DAE8D;AAC9D;EACE;IACE,qCAAqC;EACvC;;EAEA,oEAAoE;EACpE;IACE,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;8DAE8D;AAC9D;EACE;IACE,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;IACE,0CAA0C;IAC1C,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;AACF;AACA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA;;8DAE8D;AAC9D;EACE;IACE,0CAA0C;IAC1C,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;;;;IAIE,aAAa;EACf;;EAEA,mDAAmD;EACnD;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,oBAAoB,EAAE,oCAAoC;EAC5D;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oCAAoC;IACpC,gCAAgC;IAChC,0CAA0C;IAC1C,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB,EAAE,sBAAsB;IAC5C,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,+CAA+C;IAC/C,kDAAkD;EACpD;;EAEA;;IAEE,WAAW;IACX,0BAA0B;EAC5B;AACF;AACA,qDAAqD;AACrD;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".bv-hero {\n  position: relative;\n  overflow-x: clip;\n  overflow-y: visible;\n  background:\n    radial-gradient(\n      900px 460px at 8% 12%,\n      rgba(20, 184, 166, 0.1),\n      transparent 60%\n    ),\n    radial-gradient(\n      700px 420px at 90% 88%,\n      rgba(20, 184, 166, 0.1),\n      transparent 65%\n    ),\n    var(--bv-bg);\n  padding: clamp(1.5rem, 3vw, 2.5rem) 0 var(--bv-space-9);\n}\n\n.bv-hero__inner {\n  max-width: calc(var(--bv-container-wide) + (2 * var(--bv-container-px)));\n  margin-inline: auto;\n  padding-inline: var(--bv-container-px);\n  box-sizing: border-box;\n  position: relative;\n}\n\n.bv-hero__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);\n  gap: clamp(1.5rem, 3vw, 3rem);\n  align-items: center;\n  position: relative;\n  z-index: 2;\n}\n\n.bv-hero__deco {\n  pointer-events: none;\n  position: absolute;\n  z-index: 1;\n}\n\n.bv-hero__deco img {\n  width: 100%;\n  height: auto;\n}\n\n.bv-hero__deco--hotel {\n  top: 30px;\n  left: 52%;\n  width: 64px;\n  animation: bvFloatSpin 6s ease-in-out infinite;\n}\n\n.bv-hero__deco--soccer {\n  top: -30px;\n  left: 72%;\n  width: 64px;\n  animation: bvFloatSpin 6s ease-in-out infinite;\n}\n\n.bv-hero__deco--shuttle {\n  top: 8%;\n  right: 1%;\n  width: 76px;\n  animation: bvFloat 5s ease-in-out infinite 0.4s;\n}\n\n.bv-hero__copy {\n  position: relative;\n  z-index: 5;\n  animation: bvFadeUp 0.7s var(--bv-ease-out) both;\n}\n\n.bv-hero__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--bv-space-2);\n  padding: 8px 16px;\n  border-radius: var(--bv-radius-pill);\n  border: 1px solid var(--bv-primary-line);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  margin-bottom: var(--bv-space-5);\n}\n\n.bv-hero__eyebrow i {\n  color: var(--bv-primary);\n}\n\n.bv-hero__title {\n  margin: 0 0 var(--bv-space-5);\n  line-height: 1;\n  letter-spacing: -0.025em;\n}\n\n.bv-hero__title-line {\n  display: block;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-display);\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.bv-hero__title-line--teal {\n  color: var(--bv-primary);\n}\n\n.bv-hero__title-line--script {\n  font-family: var(--bv-font-script);\n  font-size: var(--bv-display-script);\n  font-weight: 700;\n  color: var(--bv-ink);\n  position: relative;\n  display: inline-block;\n  padding-bottom: 6px;\n}\n\n.bv-hero__title-line--script::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  width: 70%;\n  height: 8px;\n  background: var(--bv-primary);\n  border-radius: var(--bv-radius-pill);\n  opacity: 0.85;\n  transform: skewX(-8deg);\n}\n\n.bv-hero__lede {\n  color: var(--bv-muted);\n  font-size: var(--bv-text-lg);\n  max-width: 520px;\n  margin-bottom: var(--bv-space-6);\n}\n\n.bv-hero__search-wrap {\n  position: relative;\n  max-width: 560px;\n  margin-bottom: var(--bv-space-6);\n  z-index: 30;\n  overflow: visible;\n}\n\n.bv-hero__copy:has(.bv-hero__search-wrap.is-focused) {\n  z-index: 12;\n}\n\n.bv-hero__search-wrap.is-focused {\n  z-index: 45;\n}\n\n.bv-hero__search-wrap.is-focused ~ .bv-hero__chips {\n  position: relative;\n  z-index: 0;\n}\n\n.bv-hero__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff;\n  padding: 6px 6px 6px 10px;\n  border-radius: var(--bv-radius-pill);\n  border: 1px solid var(--bv-line);\n  box-shadow: var(--bv-shadow);\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.bv-hero__search-wrap.is-focused .bv-hero__search {\n  border-color: var(--bv-primary);\n  box-shadow:\n    0 0 0 4px rgba(20, 184, 166, 0.12),\n    var(--bv-shadow-md);\n}\n\n.bv-hero__search-pin {\n  width: 26px;\n  height: 26px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--bv-primary);\n  flex-shrink: 0;\n}\n\n.bv-hero__search-input {\n  flex: 1;\n  min-width: 0;\n}\n\n.bv-hero__search-input .search-container-head {\n  width: 100%;\n}\n\n.bv-hero__search-input .search-bar-wrapper {\n  border: 0;\n  position: relative;\n}\n\n.bv-hero__search-input .search-bar-wrapper > svg {\n  display: none;\n}\n\n.bv-hero__search-input .suggestionList {\n  display: none;\n}\n\n.bv-hero__search-input input.form-control {\n  border: none !important;\n  background: transparent !important;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base) !important;\n  color: var(--bv-ink-2);\n  padding: 10px 8px !important;\n  height: auto !important;\n  line-height: 1.4 !important;\n  box-shadow: none !important;\n}\n\n.bv-hero__search-input input.form-control::placeholder {\n  color: var(--bv-muted-2);\n}\n\n.bv-hero__search-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n  flex-shrink: 0;\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n\n.bv-hero__search-btn:hover {\n  transform: scale(1.06);\n}\n\n.bv-hero__search-input .suggestionList {\n  position: absolute;\n  top: calc(100% + 16px);\n  left: -8px;\n  right: -50px;\n  max-height: 260px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-lg);\n  box-shadow: var(--bv-shadow-md);\n  padding: 10px;\n  z-index: 60;\n  list-style: none;\n}\n\n.bv-hero__search-input .suggestion-item {\n  padding: 10px 12px;\n  border-radius: var(--bv-radius-sm);\n  cursor: pointer;\n  transition: background var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-hero__search-input .suggestion-item:hover {\n  background: var(--bv-primary-50);\n}\n\n.bv-hero__search-input .suggestion-heading {\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-ink-2);\n  margin: 0;\n}\n\n.bv-hero__search-input .suggestion-desc {\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  margin: 0;\n}\n\n.bv-hero__search-panel {\n  position: absolute;\n  top: calc(100% + 12px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-xl);\n  box-shadow: var(--bv-shadow-lg);\n  padding: 12px;\n  z-index: 50;\n  max-height: min(420px, 55vh);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  animation: bvFadeUp 0.18s var(--bv-ease-out) both;\n}\n\n.bv-hero__search-cta {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: transparent;\n  border: none;\n  padding: 12px 14px;\n  border-radius: var(--bv-radius);\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-ink);\n  cursor: pointer;\n  transition: background var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-hero__search-cta i {\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--bv-primary);\n}\n\n.bv-hero__search-cta:hover {\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n}\n\n.bv-hero__search-sub {\n  padding: 10px 14px 6px;\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-weight: 600;\n}\n\n.bv-hero__search-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.bv-hero__search-list li button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: transparent;\n  border: none;\n  padding: 10px 14px;\n  border-radius: var(--bv-radius);\n  font-size: var(--bv-text-sm);\n  color: var(--bv-ink-2);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-hero__search-list li button:hover {\n  background: var(--bv-primary-50);\n}\n\n.bv-hero__search-list li button i {\n  color: var(--bv-muted);\n  width: 16px;\n}\n\n.bv-hero__search-list li button em {\n  font-style: normal;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-xs);\n  margin-left: auto;\n}\n\n.bv-hero__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--bv-space-3);\n}\n\n.bv-hero__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 16px 6px 6px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  color: var(--bv-ink-2);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--bv-dur) var(--bv-ease);\n}\n\n.bv-hero__chip-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--bv-bg-soft);\n  border: 1px solid var(--bv-line);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding: 3px;\n}\n\n.bv-hero__chip-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.bv-hero__chip:hover {\n  border-color: var(--bv-primary);\n  color: var(--bv-primary-700);\n  box-shadow: var(--bv-shadow-sm);\n  transform: translateY(-2px);\n}\n\n.bv-hero__showcase {\n  position: relative;\n  min-height: clamp(420px, 56vh, 580px);\n  z-index: 1;\n  animation: bvFadeUp 0.8s var(--bv-ease-out) 0.1s both;\n}\n\n.bv-stage {\n  position: relative;\n  width: 100%;\n  height: clamp(420px, 56vh, 580px);\n  isolation: isolate;\n}\n\nbutton.bv-stage__card {\n  border: 5px solid #fff;\n  padding: 0;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n}\n\n.bv-stage__card {\n  position: absolute;\n  border-radius: var(--bv-radius-xl);\n  overflow: hidden;\n  background: #fff;\n  border: 5px solid #fff;\n  box-shadow: var(--bv-shadow-lg);\n  transform-origin: center center;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n  transition:\n    transform 0.38s cubic-bezier(0.22, 1, 0.36, 1),\n    box-shadow 0.38s cubic-bezier(0.22, 1, 0.36, 1);\n  will-change: transform;\n}\n\n.bv-stage__card--1 {\n  width: 30%;\n  height: 56%;\n  left: -2%;\n  top: 30%;\n  z-index: 1;\n  transform: rotate(-18deg);\n}\n\n.bv-stage__card--2 {\n  width: 36%;\n  height: 72%;\n  left: 12%;\n  top: 13%;\n  z-index: 2;\n  transform: rotate(-9deg);\n}\n\n.bv-stage__card--3 {\n  width: 42%;\n  height: 88%;\n  left: 50%;\n  top: 3%;\n  z-index: 4;\n  transform: translateX(-50%);\n}\n\n.bv-stage__card--4 {\n  width: 36%;\n  height: 72%;\n  right: 12%;\n  top: 13%;\n  z-index: 2;\n  transform: rotate(9deg);\n}\n\n.bv-stage__card--5 {\n  width: 30%;\n  height: 56%;\n  right: -2%;\n  top: 30%;\n  z-index: 1;\n  transform: rotate(18deg);\n}\n\n.bv-stage__card:hover {\n  box-shadow: var(--bv-shadow-xl);\n  z-index: 10;\n}\n\n.bv-stage__card--1:hover {\n  transform: rotate(-18deg) scale(1.04);\n}\n\n.bv-stage__card--2:hover {\n  transform: rotate(-9deg) scale(1.04);\n}\n\n.bv-stage__card--3:hover {\n  transform: translateX(-50%) scale(1.04);\n}\n\n.bv-stage__card--4:hover {\n  transform: rotate(9deg) scale(1.04);\n}\n\n.bv-stage__card--5:hover {\n  transform: rotate(18deg) scale(1.04);\n}\n\n.bv-stage__card:not(:hover) {\n  will-change: auto;\n}\n\n.bv-stage__photo {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n}\n\n.bv-stage__tag {\n  position: absolute;\n  left: 12px;\n  bottom: 12px;\n  right: 12px;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(8px);\n  border-radius: var(--bv-radius);\n  padding: 8px 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);\n  text-align: left;\n}\n\n.bv-stage__tag-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  flex-shrink: 0;\n  font-size: 12px;\n}\n\n.bv-stage__tag-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.bv-stage__tag-cat {\n  font-size: 10px;\n  text-transform: uppercase;\n  color: var(--bv-muted);\n  letter-spacing: 0.04em;\n  font-weight: 600;\n}\n\n.bv-stage__tag-name {\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  color: var(--bv-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bv-stage__tag-price {\n  font-size: 11px;\n  color: var(--bv-primary-700);\n  font-weight: 700;\n}\n\n.bv-stage__tag-icon--tennis {\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n}\n\n.bv-stage__tag-icon--basketball {\n  background: linear-gradient(135deg, #fb923c, #ea580c);\n}\n\n.bv-stage__tag-icon--football {\n  background: linear-gradient(135deg, #14b8a6, #0d9488);\n}\n\n.bv-stage__tag-icon--cricket {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n}\n\n.bv-stage__tag-icon--badminton {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n}\n\n.bv-hero__strip {\n  position: relative;\n  z-index: 1;\n  margin-top: var(--bv-space-8);\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  gap: clamp(1.5rem, 3vw, 3rem);\n  flex-wrap: wrap;\n}\n\n.bv-hero__strip > * {\n  flex: 1 1 360px;\n  min-width: 0;\n}\n\n.bv-app-pill {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: var(--bv-space-4);\n  padding: 10px 14px 10px 12px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  box-shadow: var(--bv-shadow);\n  max-width: 590px;\n}\n\n.bv-app-pill__icon {\n  position: relative;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 20px;\n  box-shadow: 0 6px 18px rgba(20, 184, 166, 0.36);\n}\n\n.bv-app-pill__dot {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: var(--bv-success);\n  border: 2px solid #fff;\n  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);\n  animation: bvPulseRing 2s ease-out infinite;\n}\n\n.bv-app-pill__text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.bv-app-pill__text strong {\n  font-family: var(--bv-font-display);\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n}\n\n.bv-app-pill__text span {\n  font-size: 0.74rem;\n  color: var(--bv-muted);\n  margin-top: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bv-app-pill__btns {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.bv-store-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  background: #fff;\n  color: var(--bv-primary-700);\n  border: 1.5px solid var(--bv-primary-line);\n  padding: 7px 14px;\n  border-radius: var(--bv-radius);\n  text-decoration: none;\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.bv-store-btn i {\n  font-size: 20px;\n  line-height: 1;\n  color: var(--bv-primary-700);\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n\n.bv-store-btn span {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n  text-align: left;\n  font-family: var(--bv-font-display);\n  font-size: 0.82rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.bv-store-btn em {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 8.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--bv-primary-700);\n  margin-bottom: 1px;\n  opacity: 0.85;\n}\n\n.bv-store-btn:hover {\n  transform: translateY(-2px);\n  background: var(--bv-grad-primary);\n  border-color: transparent;\n  color: #fff;\n  box-shadow: 0 12px 24px rgba(20, 184, 166, 0.32);\n}\n\n.bv-store-btn:hover i,\n.bv-store-btn:hover span,\n.bv-store-btn:hover em {\n  color: #fff;\n}\n\n.bv-stats-pill {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 10px 18px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  box-shadow: var(--bv-shadow);\n  max-width: 590px;\n}\n\n.bv-stats-pill__avatars {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.bv-stats-pill__avatars img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  object-fit: cover;\n  background: var(--bv-bg-soft);\n  margin-left: -10px;\n  box-shadow: var(--bv-shadow-xs);\n}\n\n.bv-stats-pill__avatars img:first-child {\n  margin-left: 0;\n}\n\n.bv-stats-pill__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.bv-stats-pill__item--avatars {\n  gap: 12px;\n}\n\n.bv-stats-pill__txt {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.15;\n  min-width: 0;\n}\n\n.bv-stats-pill__txt strong {\n  font-family: var(--bv-font-display);\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.01em;\n  line-height: 1.1;\n}\n\n.bv-stats-pill__txt span {\n  font-size: 11px;\n  color: var(--bv-muted);\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.bv-stats-pill__item--reverse .bv-stats-pill__txt {\n  text-align: right;\n}\n\n.bv-stats-pill__icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 15px;\n  position: relative;\n}\n\n.bv-stats-pill__icon--star {\n  background: linear-gradient(135deg, #fde68a, #f59e0b);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.32);\n}\n\n.bv-stats-pill__icon--venue {\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.32);\n}\n\n.bv-stats-pill__divider {\n  width: 1px;\n  height: 30px;\n  background: var(--bv-line);\n  flex-shrink: 0;\n}\n\n@media (max-width: 1100px) {\n  .bv-hero__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .bv-hero__deco {\n    display: none !important;\n  }\n\n  .bv-hero__showcase {\n    min-height: 320px;\n  }\n\n  .bv-stage {\n    max-width: 560px;\n    margin-inline: auto;\n    height: 320px;\n  }\n\n  .bv-hero__strip {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-top: var(--bv-space-6);\n  }\n\n  .bv-hero__strip > * {\n    flex: none;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  /* App pill — vertical card layout */\n  .bv-app-pill {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px 12px;\n    padding: 14px;\n    border-radius: 20px;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .bv-app-pill__icon {\n    width: 42px;\n    height: 42px;\n    font-size: 18px;\n    flex-shrink: 0;\n  }\n\n  .bv-app-pill__text {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .bv-app-pill__text span {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n  }\n\n  .bv-app-pill__btns {\n    flex: 1 1 100%;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n\n  .bv-app-pill__btns .bv-store-btn {\n    min-width: 0;\n    width: 100%;\n    justify-content: center;\n    padding: 8px 6px;\n    white-space: normal;\n  }\n\n  /* Stats pill — 3 equal columns, dividers removed from flow */\n  .bv-stats-pill {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    align-items: start;\n    gap: 10px 6px;\n    padding: 14px 10px;\n    border-radius: 20px;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .bv-stats-pill__divider {\n    display: none !important;\n  }\n\n  .bv-stats-pill__item,\n  .bv-stats-pill__item--avatars,\n  .bv-stats-pill__item--reverse {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 6px;\n    text-align: center;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .bv-stats-pill__item--reverse .bv-stats-pill__txt {\n    order: 2;\n    text-align: center;\n  }\n\n  .bv-stats-pill__item--reverse .bv-stats-pill__icon {\n    order: 1;\n  }\n\n  .bv-stats-pill__item--reverse .bv-stats-pill__txt {\n    text-align: center;\n  }\n\n  .bv-stats-pill__avatars {\n    justify-content: center;\n  }\n\n  .bv-stats-pill__txt {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .bv-stats-pill__txt span {\n    white-space: normal;\n    line-height: 1.2;\n  }\n}\n\n@media (max-width: 768px) {\n  .bv-hero {\n    overflow-x: clip;\n    padding: 1.25rem 0 var(--bv-space-7);\n  }\n\n  .bv-hero__inner {\n    padding-inline: 16px;\n  }\n\n  /* Hide main heading on mobile — eyebrow carries the hero message */\n  .bv-hero__title {\n    display: none;\n  }\n\n  .bv-hero__eyebrow {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    padding: 13px 18px;\n    margin-bottom: var(--bv-space-5);\n    font-size: 0.95rem;\n    font-weight: 700;\n    letter-spacing: 0.01em;\n    border-radius: 14px;\n    background: linear-gradient(90deg, var(--bv-primary-50) 0%, #ecfdf5 100%);\n    box-shadow: 0 4px 16px rgba(20, 184, 166, 0.12);\n  }\n\n  .bv-hero__eyebrow i {\n    font-size: 1.05rem;\n    flex-shrink: 0;\n  }\n\n  .bv-hero__lede {\n    font-size: 0.92rem;\n    line-height: 1.55;\n    margin-bottom: var(--bv-space-5);\n  }\n\n  .bv-hero__search-wrap {\n    max-width: 100%;\n    margin-bottom: var(--bv-space-5);\n  }\n\n  .bv-hero__search-btn {\n    width: 38px;\n    height: 38px;\n    font-size: 14px;\n  }\n\n  .bv-hero__chips {\n    gap: 8px;\n  }\n\n  .bv-hero__chip {\n    padding: 5px 12px 5px 5px;\n    font-size: 0.78rem;\n  }\n\n  .bv-hero__showcase {\n    min-height: 320px;\n    margin-top: 10px;\n  }\n\n  .bv-stage {\n    height: 320px;\n    max-width: 100%;\n  }\n\n  .bv-stage__card {\n    border-width: 4px;\n  }\n\n  .bv-stage__card--1,\n  .bv-stage__card--5 {\n    display: none;\n  }\n\n  .bv-stage__card--2 {\n    width: 44%;\n    height: 80%;\n    left: 0;\n    top: 12%;\n    transform: rotate(-9deg);\n  }\n\n  .bv-stage__card--2:hover {\n    transform: rotate(-9deg) scale(1.04);\n  }\n\n  .bv-stage__card--3 {\n    width: 52%;\n    height: 92%;\n    left: 50%;\n    top: 4%;\n    z-index: 4;\n    transform: translateX(-50%);\n  }\n\n  .bv-stage__card--3:hover {\n    transform: translateX(-50%) scale(1.04);\n  }\n\n  .bv-stage__card--4 {\n    width: 44%;\n    height: 80%;\n    right: 0;\n    top: 12%;\n    transform: rotate(9deg);\n  }\n\n  .bv-stage__card--4:hover {\n    transform: rotate(9deg) scale(1.04);\n  }\n\n  .bv-stage__tag {\n    display: none;\n  }\n\n  .bv-hero__search-input .suggestionList {\n    right: 0;\n    left: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .bv-hero__eyebrow {\n    font-size: 0.9rem;\n    padding: 12px 16px;\n    gap: 9px;\n  }\n\n  .bv-hero__eyebrow i {\n    font-size: 1rem;\n  }\n\n  .bv-hero__chip-icon {\n    width: 26px;\n    height: 26px;\n  }\n\n  .bv-hero__showcase {\n    min-height: 290px;\n  }\n\n  .bv-stage {\n    height: 290px;\n  }\n\n  .bv-stage__card--2 {\n    width: 46%;\n    height: 82%;\n  }\n\n  .bv-stage__card--3 {\n    width: 54%;\n    height: 94%;\n    top: 3%;\n  }\n\n  .bv-stage__card--4 {\n    width: 46%;\n    height: 82%;\n  }\n\n  .bv-app-pill {\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .bv-app-pill__icon {\n    width: 38px;\n    height: 38px;\n    font-size: 16px;\n  }\n\n  .bv-app-pill__text strong {\n    font-size: 0.88rem;\n  }\n\n  .bv-app-pill__text span {\n    font-size: 0.7rem;\n  }\n\n  .bv-store-btn {\n    padding: 7px 4px;\n    gap: 6px;\n  }\n\n  .bv-store-btn i {\n    font-size: 16px;\n  }\n\n  .bv-store-btn span {\n    font-size: 11px;\n  }\n\n  .bv-store-btn em {\n    font-size: 7px;\n  }\n\n  .bv-stats-pill {\n    padding: 12px 6px;\n    gap: 8px 4px;\n  }\n\n  .bv-stats-pill__avatars img {\n    width: 22px;\n    height: 22px;\n    margin-left: -7px;\n  }\n\n  .bv-stats-pill__icon {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n    border-radius: 8px;\n  }\n\n  .bv-stats-pill__txt strong {\n    font-size: 0.82rem;\n  }\n\n  .bv-stats-pill__txt span {\n    font-size: 9px;\n  }\n}\n\n.bv-offers {\n  background: var(--bv-bg);\n  padding: clamp(1rem, 2vw, 1.75rem) 0;\n}\n\n.bv-offers__pill {\n  max-width: var(--bv-container-wide);\n  margin-inline: auto;\n  padding: 10px 18px 10px 10px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #ecfdf5 0%, #d1fae5 100%);\n  border: 1px solid rgba(20, 184, 166, 0.18);\n  box-shadow: 0 8px 30px rgba(20, 184, 166, 0.08);\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 14px;\n  position: relative;\n}\n\n.bv-offers__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 18px 6px 6px;\n  border-radius: 999px;\n  background: #fff;\n  color: var(--bv-primary-700);\n  border: 1.5px solid rgba(20, 184, 166, 0.3);\n  box-shadow: 0 6px 18px rgba(20, 184, 166, 0.14);\n  flex-shrink: 0;\n  position: relative;\n}\n\n.bv-offers__badge-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #fff;\n  box-shadow: 0 6px 14px rgba(20, 184, 166, 0.32);\n  position: relative;\n}\n\n.bv-offers__badge-icon::after {\n  content: \"\";\n  position: absolute;\n  inset: -3px;\n  border-radius: 50%;\n  border: 1.5px solid rgba(20, 184, 166, 0.32);\n  animation: bvBadgeRing 2.2s ease-out infinite;\n}\n\n@keyframes bvBadgeRing {\n  0% {\n    transform: scale(0.92);\n    opacity: 0.8;\n  }\n\n  70% {\n    transform: scale(1.2);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1.2);\n    opacity: 0;\n  }\n}\n\n.bv-offers__badge-text {\n  font-family: var(--bv-font-display);\n  font-size: 0.82rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n  text-transform: uppercase;\n  background: linear-gradient(\n    90deg,\n    var(--bv-primary-700) 0%,\n    var(--bv-primary) 100%\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.bv-offers__track-wrap {\n  overflow: hidden;\n  position: relative;\n  min-width: 0;\n  -webkit-mask-image: linear-gradient(\n    90deg,\n    transparent 0,\n    #000 4%,\n    #000 96%,\n    transparent 100%\n  );\n  mask-image: linear-gradient(\n    90deg,\n    transparent 0,\n    #000 4%,\n    #000 96%,\n    transparent 100%\n  );\n}\n\n.bv-offers__track {\n  display: inline-flex;\n  align-items: center;\n  gap: 0;\n  width: max-content;\n  animation: bvOffersScroll 36s linear infinite;\n}\n\n.bv-offers:hover .bv-offers__track {\n  animation-play-state: paused;\n}\n\n@keyframes bvOffersScroll {\n  from {\n    transform: translateX(0);\n  }\n\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n.bv-offers__group {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.bv-offers__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 14px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.bv-offers__item-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #fff;\n  border: 1px solid rgba(20, 184, 166, 0.18);\n  color: var(--bv-primary-700);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  flex-shrink: 0;\n  box-shadow: 0 2px 6px rgba(20, 184, 166, 0.1);\n}\n\n.bv-offers__item-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.15;\n}\n\n.bv-offers__item-text > span {\n  font-family: var(--bv-font-display);\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--bv-ink);\n}\n\n.bv-offers__item-text > span strong {\n  color: var(--bv-primary-700);\n  font-weight: 800;\n}\n\n.bv-offers__item-text em {\n  font-style: normal;\n  font-size: 0.74rem;\n  font-weight: 500;\n  color: var(--bv-muted);\n  margin-top: 2px;\n}\n\n.bv-offers__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--bv-primary);\n  opacity: 0.55;\n  flex-shrink: 0;\n  margin-inline: 4px;\n}\n\n@media (max-width: 768px) {\n  .bv-offers__pill {\n    border-radius: 28px;\n    padding: 8px 12px 8px 8px;\n    gap: 10px;\n  }\n\n  .bv-offers__badge {\n    padding: 6px 14px 6px 6px;\n  }\n\n  .bv-offers__badge-text {\n    font-size: 0.72rem;\n  }\n\n  .bv-offers__item-text em {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .bv-offers__badge-text {\n    display: none;\n  }\n\n  .bv-offers__badge {\n    padding: 6px;\n  }\n}\n\n.bv-section--listings {\n  background: var(--bv-bg-cream);\n}\n\n.bv-featured {\n  padding-block: var(--bv-section-y);\n  background: var(--bv-bg);\n}\n\n.bv-featured__head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: var(--bv-space-5);\n  margin-bottom: var(--bv-space-7);\n  flex-wrap: wrap;\n}\n\n.bv-featured__head-left {\n  max-width: 720px;\n}\n\n.bv-featured__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--bv-font-display);\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  color: var(--bv-primary-700);\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n\n.bv-featured__eyebrow i {\n  color: var(--bv-primary);\n  font-size: 14px;\n}\n\n.bv-featured__title {\n  margin: 0 0 12px;\n}\n\n.bv-featured__lede {\n  color: var(--bv-muted);\n  font-size: var(--bv-text-base);\n  max-width: 620px;\n  margin: 0;\n  line-height: 1.6;\n}\n\n.bv-featured__view-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 11px 22px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid var(--bv-primary);\n  color: var(--bv-primary-700);\n  background: transparent;\n  font-family: var(--bv-font-display);\n  font-weight: 700;\n  font-size: 0.92rem;\n  text-decoration: none;\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.bv-featured__view-all i {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--bv-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n\n.bv-featured__view-all:hover {\n  background: var(--bv-primary);\n  color: #fff;\n  transform: translateY(-2px);\n  box-shadow: var(--bv-shadow-teal);\n}\n\n.bv-featured__view-all:hover i {\n  background: #fff;\n  color: var(--bv-primary);\n  transform: translateX(3px);\n}\n\n.bv-featured__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);\n  gap: clamp(1rem, 2vw, 1.75rem);\n  align-items: start;\n}\n\n.bv-featured__hero {\n  display: flex;\n  flex-direction: column;\n}\n\n.bv-featured__hero-card {\n  position: relative;\n  border-radius: 24px;\n  overflow: hidden;\n  isolation: isolate;\n  background: var(--bv-ink);\n  box-shadow:\n    0 30px 60px -20px rgba(15, 23, 42, 0.28),\n    0 0 0 1px rgba(255, 255, 255, 0.04);\n  aspect-ratio: 4 / 3.4;\n}\n\n.bv-featured__hero-imgs {\n  position: absolute;\n  inset: 0;\n}\n\n.bv-featured__hero-img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transform: scale(1.04);\n  transition:\n    opacity 0.55s var(--bv-ease-out),\n    transform 0.8s var(--bv-ease-out);\n}\n\n.bv-featured__hero-img.is-active {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.bv-featured__hero-overlay {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(\n      180deg,\n      rgba(15, 23, 42, 0) 25%,\n      rgba(15, 23, 42, 0.45) 75%,\n      rgba(15, 23, 42, 0.65) 100%\n    ),\n    linear-gradient(90deg, rgba(15, 23, 42, 0.2) 0%, transparent 35%);\n  pointer-events: none;\n}\n\n.bv-featured__hero-badge {\n  position: absolute;\n  top: 18px;\n  left: 18px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 14px 7px 12px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-ink);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-weight: 700;\n  font-size: 0.78rem;\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.3);\n  z-index: 2;\n}\n\n.bv-featured__hero-badge i {\n  color: #fbbf24;\n  font-size: 12px;\n}\n\n.bv-featured__hero-arrow {\n  position: absolute;\n  top: 36%;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.96);\n  color: var(--bv-ink);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.3);\n  z-index: 4;\n  border: none;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.bv-featured__hero-arrow--prev {\n  left: 18px;\n}\n\n.bv-featured__hero-arrow--next {\n  right: 18px;\n}\n\n.bv-featured__hero-arrow:hover {\n  background: var(--bv-primary);\n  color: #fff;\n  transform: scale(1.05);\n}\n\n.bv-featured__hero-info {\n  position: absolute;\n  left: 18px;\n  bottom: 157px;\n  z-index: 3;\n  background: rgba(255, 255, 255, 0.82);\n  backdrop-filter: blur(18px) saturate(140%);\n  -webkit-backdrop-filter: blur(18px) saturate(140%);\n  padding: 16px 18px;\n  border-radius: 16px;\n  max-width: 320px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.bv-featured__hero-info-loc {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--bv-muted);\n  margin: 0;\n}\n\n.bv-featured__hero-info-loc i {\n  color: var(--bv-primary);\n  font-size: 11px;\n}\n\n.bv-featured__hero-info-title {\n  font-family: var(--bv-font-display);\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.01em;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.bv-featured__hero-info-desc {\n  font-size: 0.78rem;\n  color: var(--bv-muted);\n  line-height: 1.5;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.bv-featured__hero-info-btn {\n  align-self: flex-start;\n  margin-top: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 6px 6px 16px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-grad-primary);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-weight: 700;\n  font-size: 0.82rem;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.32);\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.bv-featured__hero-info-btn span {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.22);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n}\n\n.bv-featured__hero-info-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 28px rgba(20, 184, 166, 0.45);\n}\n\n.bv-featured__gallery {\n  position: absolute;\n  left: 18px;\n  right: 18px;\n  bottom: 18px;\n  z-index: 2;\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 8px;\n  padding: 6px;\n  background: rgba(15, 23, 42, 0.36);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.bv-featured__gallery-thumb {\n  position: relative;\n  aspect-ratio: 16 / 11;\n  border-radius: 9px;\n  overflow: hidden;\n  background: var(--bv-bg-soft);\n  border: 2px solid transparent;\n  cursor: pointer;\n  padding: 0;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.bv-featured__gallery-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: brightness(0.75);\n  transition:\n    filter var(--bv-dur) var(--bv-ease),\n    transform 0.6s var(--bv-ease-out);\n}\n\n.bv-featured__gallery-thumb:hover img {\n  filter: brightness(1);\n  transform: scale(1.06);\n}\n\n.bv-featured__gallery-thumb.is-active {\n  border-color: #5eead4;\n  box-shadow: 0 4px 14px rgba(94, 234, 212, 0.45);\n}\n\n.bv-featured__gallery-thumb.is-active img {\n  filter: brightness(1.05);\n}\n\n.bv-featured__side {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.bv-featured__mini {\n  position: relative;\n  display: grid;\n  grid-template-columns: 118px 1fr auto;\n  align-items: stretch;\n  gap: 12px;\n  padding: 10px;\n  border-radius: 18px;\n  background: #fff;\n  border: 1.5px solid var(--bv-line);\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease);\n}\n\n.bv-featured__mini:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--bv-shadow-card-hover);\n  border-color: transparent;\n}\n\n.bv-featured__mini.is-active {\n  border-color: var(--bv-primary);\n  background: linear-gradient(180deg, #fff 0%, #f0fdfa 100%);\n  box-shadow: 0 12px 28px -10px rgba(20, 184, 166, 0.45);\n}\n\n.bv-featured__mini.is-active::before {\n  content: \"\";\n  position: absolute;\n  left: -10px;\n  top: 50%;\n  width: 4px;\n  height: 36px;\n  border-radius: 4px;\n  background: var(--bv-primary);\n  transform: translateY(-50%);\n  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.45);\n}\n\n.bv-featured__mini-overlay {\n  position: absolute;\n  inset: 0;\n  background: transparent;\n  border: none;\n  border-radius: 18px;\n  cursor: pointer;\n  z-index: 1;\n  padding: 0;\n}\n\n.bv-featured__mini-overlay:focus-visible {\n  outline: 2px solid var(--bv-primary);\n  outline-offset: 3px;\n}\n\n.bv-featured__mini-media,\n.bv-featured__mini-body {\n  position: relative;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.bv-featured__mini-media {\n  position: relative;\n  width: 118px;\n  height: 118px;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--bv-bg-soft);\n  flex-shrink: 0;\n}\n\n.bv-featured__mini-media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s var(--bv-ease-out);\n}\n\n.bv-featured__mini:hover .bv-featured__mini-media img {\n  transform: scale(1.08);\n}\n\n.bv-featured__mini-icon {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.96);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--bv-shadow-xs);\n  padding: 4px;\n}\n\n.bv-featured__mini-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.bv-featured__mini-body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  align-self: center;\n}\n\n.bv-featured__mini-body h3 {\n  font-family: var(--bv-font-display);\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.01em;\n  margin: 0;\n  line-height: 1.2;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.bv-featured__mini-loc {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: var(--bv-muted);\n  font-weight: 500;\n  margin: 0;\n}\n\n.bv-featured__mini-loc i {\n  color: var(--bv-primary);\n  font-size: 10px;\n}\n\n.bv-featured__mini-desc {\n  font-size: 0.78rem;\n  color: var(--bv-muted);\n  margin: 0;\n  line-height: 1.45;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.bv-featured__mini-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.bv-featured__mini-tags > span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 9px 3px 3px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid rgba(20, 184, 166, 0.18);\n  color: var(--bv-primary-700);\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  letter-spacing: 0;\n}\n\n.bv-featured__mini-tag-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px;\n  box-shadow: 0 1px 3px rgba(20, 184, 166, 0.18);\n}\n\n.bv-featured__mini-tag-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.bv-featured__mini-arrow {\n  position: relative;\n  z-index: 2;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--bv-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  align-self: center;\n  flex-shrink: 0;\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n  box-shadow: 0 6px 16px rgba(20, 184, 166, 0.32);\n  text-decoration: none;\n}\n\n.bv-featured__mini-arrow:hover {\n  color: #fff;\n}\n\n.bv-featured__mini:hover .bv-featured__mini-arrow {\n  transform: translateX(3px) scale(1.05);\n  box-shadow: 0 10px 22px rgba(20, 184, 166, 0.42);\n}\n\n.bv-featured__empty {\n  text-align: center;\n  padding: var(--bv-space-7);\n  color: var(--bv-muted);\n  font-style: italic;\n}\n\n@media (max-width: 1280px) {\n  .bv-featured__hero-info {\n    max-width: 360px;\n    padding: 14px 16px;\n  }\n\n  .bv-featured__hero-info-title {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 1100px) {\n  .bv-featured__grid {\n    grid-template-columns: 1fr;\n    gap: 28px;\n  }\n\n  .bv-featured__hero-card {\n    aspect-ratio: 16 / 10;\n  }\n\n  .bv-featured__hero-info {\n    max-width: 380px;\n  }\n\n  .bv-featured__side {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    display: grid;\n    gap: 14px;\n  }\n}\n\n@media (max-width: 820px) {\n  .bv-featured__head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .bv-featured__hero-card {\n    aspect-ratio: 4 / 3.6;\n  }\n\n  .bv-featured__hero-info {\n    left: 14px;\n    right: 14px;\n    bottom: 96px;\n    max-width: none;\n    padding: 12px 14px;\n  }\n\n  .bv-featured__hero-info-title {\n    font-size: 1rem;\n  }\n\n  .bv-featured__hero-info-desc {\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n  }\n\n  .bv-featured__hero-arrow {\n    width: 36px;\n    height: 36px;\n    top: 32%;\n  }\n\n  .bv-featured__gallery {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    left: 12px;\n    right: 12px;\n    bottom: 12px;\n    padding: 5px;\n    gap: 6px;\n  }\n\n  .bv-featured__side {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .bv-featured__mini {\n    grid-template-columns: 100px 1fr auto;\n    gap: 12px;\n    padding: 10px;\n  }\n\n  .bv-featured__mini-media {\n    width: 100px;\n    height: 100px;\n  }\n\n  .bv-featured__mini-body h3 {\n    font-size: 0.92rem;\n  }\n\n  .bv-featured__mini-arrow {\n    width: 36px;\n    height: 36px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 600px) {\n  .bv-featured__hero-card {\n    aspect-ratio: 4 / 4.4;\n  }\n\n  .bv-featured__side {\n    grid-template-columns: 1fr;\n  }\n\n  .bv-featured__hero-info {\n    left: 10px;\n    right: 10px;\n    bottom: 90px;\n    max-width: none;\n    padding: 10px 12px;\n  }\n\n  .bv-featured__hero-info-title {\n    font-size: 0.95rem;\n  }\n\n  .bv-featured__hero-info-desc {\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    font-size: 0.72rem;\n  }\n\n  .bv-featured__gallery {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    left: 8px;\n    right: 8px;\n    bottom: 8px;\n    gap: 4px;\n    padding: 4px;\n  }\n\n  .bv-featured__mini {\n    grid-template-columns: 90px 1fr 36px;\n    gap: 10px;\n    padding: 10px;\n  }\n\n  .bv-featured__mini-media {\n    width: 90px;\n    height: 90px;\n  }\n\n  .bv-featured__mini-body h3 {\n    font-size: 0.88rem;\n  }\n\n  .bv-featured__mini-desc {\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n  }\n\n  .bv-featured__mini-tags {\n    gap: 4px;\n  }\n\n  .bv-featured__mini-tags > span {\n    padding: 2px 7px 2px 2px;\n    font-size: 0.62rem;\n  }\n\n  .bv-featured__mini-tag-icon {\n    width: 16px;\n    height: 16px;\n    padding: 2px;\n  }\n}\n\n@media (max-width: 420px) {\n  .bv-featured__hero-info-btn {\n    padding: 5px 5px 5px 12px;\n    font-size: 0.74rem;\n  }\n\n  .bv-featured__hero-info-btn span {\n    width: 20px;\n    height: 20px;\n  }\n\n  .bv-featured__hero-info {\n    padding: 8px 10px;\n  }\n}\n\n.bv-view-all-wrap {\n  text-align: center;\n  margin-top: var(--bv-space-9);\n}\n\n.bv-section--faq {\n  background: #fff;\n}\n\n.bv-faq-wrap {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.2fr);\n  gap: clamp(2rem, 4vw, 4rem);\n  align-items: start;\n}\n\n.bv-faq-aside {\n  position: sticky;\n  top: 110px;\n  padding: var(--bv-space-7);\n  border-radius: var(--bv-radius-2xl);\n  background: linear-gradient(160deg, var(--bv-primary-50) 0%, #ffffff 70%);\n  border: 1px solid var(--bv-primary-line);\n  overflow: hidden;\n}\n\n.bv-faq-aside .bv-section-eyebrow {\n  background: #fff;\n  margin-bottom: var(--bv-space-5);\n}\n\n.bv-faq-aside__title {\n  margin-bottom: var(--bv-space-4);\n}\n\n.bv-faq-aside__lede {\n  color: var(--bv-muted);\n  font-size: var(--bv-text-base);\n  line-height: 1.7;\n  margin-bottom: var(--bv-space-6);\n}\n\n.bv-faq-aside__btn {\n  background: #fff;\n}\n\n.bv-faq-aside__deco {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.bv-faq-aside__ball {\n  position: absolute;\n  opacity: 0.85;\n  filter: drop-shadow(0 8px 18px rgba(15, 23, 42, 0.12));\n}\n\n.bv-faq-aside__ball--1 {\n  width: 70px;\n  top: -10px;\n  right: 12px;\n  animation: bvFloat 5s ease-in-out infinite;\n}\n\n.bv-faq-aside__ball--2 {\n  width: 50px;\n  bottom: 24px;\n  right: 60px;\n  animation: bvFloat 6s ease-in-out infinite 0.6s;\n}\n\n.bv-faq-aside__ball--3 {\n  width: 56px;\n  top: 56%;\n  right: -16px;\n  animation: bvFloat 5.5s ease-in-out infinite 1s;\n}\n\n.bv-faq-aside > * {\n  position: relative;\n  z-index: 1;\n}\n\n.bv-faq-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-4);\n}\n\n.bv-faq-item {\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-xl);\n  overflow: hidden;\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.bv-faq-item:hover {\n  border-color: var(--bv-primary-line);\n  box-shadow: var(--bv-shadow);\n  transform: translateY(-2px);\n}\n\n.bv-faq-item.is-open {\n  border-color: var(--bv-primary);\n  box-shadow:\n    0 0 0 4px rgba(20, 184, 166, 0.1),\n    var(--bv-shadow);\n}\n\n.bv-faq-item__btn {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 44px 1fr 36px;\n  align-items: center;\n  gap: 16px;\n  background: transparent;\n  border: none;\n  padding: 14px 16px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.bv-faq-item__num {\n  width: 44px;\n  height: 44px;\n  border-radius: var(--bv-radius);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--bv-font-display);\n  font-weight: 800;\n  font-size: var(--bv-text-base);\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.bv-faq-item.is-open .bv-faq-item__num {\n  background: var(--bv-grad-primary);\n  color: #fff;\n}\n\n.bv-faq-item__q {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-base);\n  font-weight: 600;\n  color: var(--bv-ink);\n  line-height: 1.4;\n}\n\n.bv-faq-item__chev {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--bv-bg-soft);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--bv-ink-2);\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n\n.bv-faq-item.is-open .bv-faq-item__chev {\n  background: var(--bv-primary);\n  color: #fff;\n  transform: rotate(180deg);\n}\n\n.bv-faq-item__body {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height var(--bv-dur-slow) var(--bv-ease-out);\n}\n\n.bv-faq-item.is-open .bv-faq-item__body {\n  max-height: 360px;\n}\n\n.bv-faq-item__body-inner {\n  padding: 0 16px 16px 72px;\n  color: var(--bv-muted);\n  font-size: var(--bv-text-sm);\n  line-height: 1.7;\n}\n\n@media (max-width: 992px) {\n  .bv-faq-wrap {\n    grid-template-columns: 1fr;\n  }\n\n  .bv-faq-aside {\n    position: static;\n  }\n\n  .bv-faq-item__body-inner {\n    padding-left: 16px;\n  }\n}\n\n.slick-prev,\n.slick-next {\n  width: 44px !important;\n  height: 44px !important;\n  background: #fff !important;\n  border-radius: 50% !important;\n  box-shadow: var(--bv-shadow) !important;\n  border: 1px solid var(--bv-line) !important;\n  z-index: 5 !important;\n  transition: all var(--bv-dur) var(--bv-ease) !important;\n}\n\n.slick-prev:hover,\n.slick-next:hover {\n  background: var(--bv-grad-primary) !important;\n  border-color: transparent !important;\n  transform: scale(1.06);\n}\n\n.slick-prev::before,\n.slick-next::before {\n  font-family:\n    \"Font Awesome 6 Free\", \"Font Awesome 5 Free\", sans-serif !important;\n  font-weight: 900 !important;\n  color: var(--bv-ink) !important;\n  opacity: 1 !important;\n  font-size: 14px !important;\n  transition: color var(--bv-dur) var(--bv-ease) !important;\n}\n\n.slick-prev::before {\n  content: \"\\f060\" !important;\n}\n\n.slick-next::before {\n  content: \"\\f061\" !important;\n}\n\n.slick-prev:hover::before,\n.slick-next:hover::before {\n  color: #fff !important;\n}\n\n.slick-prev {\n  left: -8px !important;\n}\n\n.slick-next {\n  right: -8px !important;\n}\n\n.slick-list {\n  margin: 0 -8px !important;\n  padding: 8px 0 !important;\n}\n\n.slick-slide > div {\n  padding: 0 8px;\n}\n\n@media (max-width: 768px) {\n  .slick-prev,\n  .slick-next {\n    width: 38px !important;\n    height: 38px !important;\n  }\n\n  .slick-prev {\n    left: -4px !important;\n  }\n\n  .slick-next {\n    right: -4px !important;\n  }\n}\n\n/* ---- Right sticky back-to-top FAB ---- */\n.bv-back-top {\n  position: fixed;\n  right: clamp(1rem, 2.4vw, 1.75rem);\n  top: 50%;\n  z-index: 45;\n  width: 52px;\n  height: 52px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-50%) translateX(calc(100% + 20px)) scale(0.88);\n  transition:\n    transform var(--bv-dur-slow) var(--bv-ease-out),\n    opacity var(--bv-dur) var(--bv-ease);\n}\n\n.bv-back-top.is-visible {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(-50%) translateX(0) scale(1);\n}\n\n.bv-back-top:focus-visible {\n  outline: none;\n}\n\n.bv-back-top:focus-visible .bv-back-top__icon {\n  box-shadow:\n    0 0 0 3px rgba(20, 184, 166, 0.28),\n    var(--bv-shadow-teal);\n}\n\n.bv-back-top__ring {\n  position: absolute;\n  inset: 0;\n  filter: drop-shadow(0 4px 12px rgba(15, 23, 42, 0.08));\n  transition: filter var(--bv-dur) var(--bv-ease);\n}\n\n.bv-back-top:hover .bv-back-top__ring,\n.bv-back-top:focus-visible .bv-back-top__ring {\n  filter: drop-shadow(0 8px 20px rgba(20, 184, 166, 0.28));\n}\n\n.bv-back-top__ring svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.bv-back-top__ring-track {\n  fill: none;\n  stroke: rgba(226, 232, 240, 0.95);\n  stroke-width: 3;\n}\n\n.bv-back-top__ring-fill {\n  fill: none;\n  stroke: url(#bvBackTopGrad);\n  stroke-width: 3;\n  stroke-linecap: round;\n  transition: stroke-dashoffset var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-back-top__icon {\n  position: absolute;\n  inset: 6px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid var(--bv-primary-line);\n  box-shadow: var(--bv-shadow-sm);\n  color: var(--bv-primary-700);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.95rem;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease-spring);\n}\n\n.bv-back-top:hover .bv-back-top__icon,\n.bv-back-top:focus-visible .bv-back-top__icon {\n  background: var(--bv-grad-primary);\n  border-color: transparent;\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .bv-back-top {\n    top: auto;\n    bottom: calc(92px + env(safe-area-inset-bottom, 0px));\n    width: 48px;\n    height: 48px;\n    transform: translateY(0) translateX(calc(100% + 20px)) scale(0.88);\n  }\n\n  .bv-back-top.is-visible {\n    transform: translateY(0) translateX(0) scale(1);\n  }\n\n  .bv-back-top__icon {\n    inset: 5px;\n    font-size: 0.88rem;\n  }\n}\n\n/* ---- Sticky WhatsApp chat (homepage) ---- */\n.bv-wa-chat {\n  position: fixed;\n  right: clamp(1rem, 2.4vw, 1.75rem);\n  left: auto;\n  bottom: calc(1.5rem + env(safe-area-inset-bottom, 0px));\n  z-index: 44;\n  isolation: isolate;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px 8px 8px;\n  border-radius: var(--bv-radius-pill, 999px);\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(37, 211, 102, 0.22);\n  color: #15803d;\n  text-decoration: none;\n  font-family: var(--bv-font-display, inherit);\n  font-size: var(--bv-text-sm, 0.875rem);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1;\n  box-shadow:\n    0 4px 18px rgba(15, 23, 42, 0.07),\n    0 1px 3px rgba(37, 211, 102, 0.1);\n  transition:\n    transform var(--bv-dur, 280ms)\n      var(--bv-ease-spring, cubic-bezier(0.34, 1.4, 0.64, 1)),\n    box-shadow var(--bv-dur, 280ms) var(--bv-ease, ease),\n    border-color var(--bv-dur, 280ms) var(--bv-ease, ease),\n    background var(--bv-dur, 280ms) var(--bv-ease, ease);\n  animation: bvWaChatIn 0.5s var(--bv-ease-out, ease) 0.5s both;\n}\n\n.bv-wa-chat:hover,\n.bv-wa-chat:focus-visible {\n  color: #166534;\n  background: #fff;\n  border-color: rgba(37, 211, 102, 0.38);\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(15, 23, 42, 0.09),\n    0 2px 8px rgba(37, 211, 102, 0.14);\n}\n\n.bv-wa-chat:focus-visible {\n  outline: none;\n  box-shadow:\n    0 0 0 3px rgba(37, 211, 102, 0.18),\n    0 8px 24px rgba(15, 23, 42, 0.09);\n}\n\n.bv-wa-chat__pulse {\n  position: absolute;\n  inset: -2px;\n  border-radius: inherit;\n  border: 1px solid rgba(37, 211, 102, 0.28);\n  animation: bvWaPulse 3s ease-out infinite;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.bv-wa-chat__icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: linear-gradient(145deg, #34d399 0%, #25d366 100%);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.15rem;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(37, 211, 102, 0.28);\n}\n\n.bv-wa-chat__label {\n  padding-right: 4px;\n  white-space: nowrap;\n  opacity: 0.92;\n}\n\n@keyframes bvWaPulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.45;\n  }\n\n  70% {\n    transform: scale(1.1);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(1.1);\n    opacity: 0;\n  }\n}\n\n@keyframes bvWaChatIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .bv-wa-chat {\n    right: clamp(0.75rem, 3vw, 1rem);\n    bottom: calc(1rem + env(safe-area-inset-bottom, 0px));\n    padding: 7px 14px 7px 7px;\n    gap: 7px;\n  }\n\n  .bv-wa-chat__icon {\n    width: 30px;\n    height: 30px;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 380px) {\n  .bv-wa-chat__label {\n    font-size: var(--bv-text-xs, 0.75rem);\n  }\n}\n\n.section {\n  padding-block: var(--bv-section-y);\n}\n\n.section-heading {\n  text-align: center;\n  margin: 0 0 var(--bv-space-9);\n}\n\n.section-heading h2 {\n  margin: 0 0 var(--bv-space-3);\n}\n\n.section-heading p,\n.sub-title {\n  color: var(--bv-muted);\n  max-width: 640px;\n  margin: 0 auto;\n  font-size: var(--bv-text-lg);\n}\n/* =========================================================\n   SPOTLIGHT — SAME BROCODE LIGHT / TEAL THEME\n   ========================================================= */\n\n.spotlight-layout {\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(250px, 0.78fr) minmax(0, 1.45fr);\n  gap: clamp(1rem, 2vw, 1.75rem);\n  align-items: stretch;\n  color: var(--bv-ink);\n}\n\n/* =========================================================\n   LEFT VENUE LIST\n   ========================================================= */\n\n.spotlight-list {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n\n/* VENUE ITEM */\n\n.spotlight-item {\n  appearance: none;\n  -webkit-appearance: none;\n\n  position: relative;\n\n  width: 100%;\n  min-height: 78px;\n\n  display: flex;\n  align-items: center;\n  gap: 14px;\n\n  padding: 14px 16px;\n\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-md, 16px);\n\n  background: #fff;\n  color: var(--bv-ink);\n\n  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.055);\n\n  cursor: pointer;\n  text-align: left;\n\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.spotlight-item:hover {\n  transform: translateX(5px);\n\n  border-color: rgba(20, 184, 166, 0.35);\n\n  background: #f8fffd;\n\n  box-shadow: 0 10px 28px rgba(20, 184, 166, 0.1);\n}\n\n/* ACTIVE */\n\n.spotlight-item--active {\n  background: linear-gradient(\n    135deg,\n    var(--bv-primary-50, #f0fdfa) 0%,\n    #ffffff 100%\n  );\n\n  border-color: rgba(20, 184, 166, 0.45);\n\n  box-shadow:\n    0 12px 30px rgba(20, 184, 166, 0.12),\n    inset 3px 0 0 var(--bv-primary);\n\n  transform: translateX(5px);\n}\n\n/* =========================================================\n   NUMBER\n   ========================================================= */\n\n.spotlight-item__number {\n  flex: 0 0 auto;\n\n  width: 34px;\n  height: 34px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 10px;\n\n  background: var(--bv-bg-cream);\n\n  color: var(--bv-primary-700);\n\n  font-family: var(--bv-font-display);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.spotlight-item--active .spotlight-item__number {\n  background: var(--bv-grad-primary);\n  color: #fff;\n\n  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.25);\n}\n\n/* =========================================================\n   CONTENT\n   ========================================================= */\n\n.spotlight-item__content {\n  min-width: 0;\n  flex: 1;\n\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.spotlight-item__name {\n  display: block;\n\n  margin: 0;\n\n  color: var(--bv-ink);\n\n  font-family: var(--bv-font-display);\n\n  font-size: 0.98rem;\n  line-height: 1.25;\n  font-weight: 800;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.spotlight-item--active .spotlight-item__name {\n  color: var(--bv-primary-700);\n}\n\n.spotlight-item__location {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  margin: 0;\n\n  color: var(--bv-muted);\n\n  font-size: 0.72rem;\n  line-height: 1.3;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.spotlight-item__location i {\n  flex-shrink: 0;\n  color: var(--bv-primary);\n}\n\n/* =========================================================\n   ITEM ARROW\n   ========================================================= */\n\n.spotlight-item__arrow {\n  flex: 0 0 32px;\n\n  width: 32px;\n  height: 32px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  background: var(--bv-primary-50, #f0fdfa);\n\n  color: var(--bv-primary-700);\n\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.spotlight-item:hover .spotlight-item__arrow,\n.spotlight-item--active .spotlight-item__arrow {\n  background: var(--bv-grad-primary);\n  color: #fff;\n\n  transform: translateX(2px);\n\n  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.25);\n}\n\n/* =========================================================\n   RIGHT HERO\n   ========================================================= */\n\n.spotlight-hero {\n  width: 100%;\n  min-width: 0;\n}\n\n.spotlight-hero__card {\n  position: relative;\n\n  width: 100%;\n  min-height: 540px;\n\n  overflow: hidden;\n  isolation: isolate;\n\n  border-radius: 24px;\n\n  background: var(--bv-ink);\n\n  box-shadow:\n    0 30px 60px -20px rgba(15, 23, 42, 0.28),\n    0 0 0 1px rgba(255, 255, 255, 0.05);\n}\n\n/* =========================================================\n   HERO IMAGE\n   ========================================================= */\n\n.spotlight-hero__images {\n  position: absolute;\n  inset: 0;\n\n  width: 100%;\n  height: 100%;\n}\n\n.spotlight-hero__image {\n  position: absolute;\n  inset: 0;\n\n  width: 100%;\n  height: 100%;\n\n  display: block;\n\n  object-fit: cover;\n\n  opacity: 0;\n\n  transform: scale(1.04);\n\n  transition:\n    opacity 0.55s var(--bv-ease-out),\n    transform 0.8s var(--bv-ease-out);\n}\n\n.spotlight-hero__image--active {\n  opacity: 1;\n  transform: scale(1);\n}\n\n/* =========================================================\n   HERO OVERLAY\n   ========================================================= */\n\n.spotlight-hero__overlay {\n  position: absolute;\n  inset: 0;\n\n  z-index: 2;\n\n  pointer-events: none;\n\n  background:\n    linear-gradient(\n      180deg,\n      rgba(15, 23, 42, 0.02) 20%,\n      rgba(15, 23, 42, 0.16) 48%,\n      rgba(15, 23, 42, 0.72) 100%\n    ),\n    linear-gradient(90deg, rgba(15, 23, 42, 0.12), transparent 45%);\n}\n\n/* =========================================================\n   POPULAR BADGE\n   ========================================================= */\n\n.spotlight-hero__badge {\n  position: absolute;\n\n  top: 20px;\n  left: 20px;\n\n  z-index: 5;\n\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n\n  padding: 8px 13px;\n\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  border-radius: var(--bv-radius-pill, 999px);\n\n  background: rgba(255, 255, 255, 0.88);\n\n  color: var(--bv-primary-700);\n\n  font-family: var(--bv-font-display);\n\n  font-size: 0.72rem;\n  font-weight: 800;\n\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);\n\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.spotlight-hero__badge i {\n  color: #f59e0b;\n}\n\n/* =========================================================\n   HERO NAVIGATION\n   ========================================================= */\n\n.spotlight-hero__navigation {\n  position: absolute;\n\n  top: 20px;\n  right: 20px;\n\n  z-index: 5;\n\n  display: flex;\n  gap: 8px;\n}\n\n.spotlight-hero__navigation button {\n  appearance: none;\n  -webkit-appearance: none;\n\n  width: 38px;\n  height: 38px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 0;\n\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n\n  background: rgba(255, 255, 255, 0.88);\n\n  color: var(--bv-primary-700);\n\n  cursor: pointer;\n\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);\n\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.spotlight-hero__navigation button:hover {\n  background: var(--bv-grad-primary);\n  color: #fff;\n\n  transform: translateY(-2px);\n}\n\n/* =========================================================\n   HERO INFORMATION\n   ========================================================= */\n\n.spotlight-hero__info {\n  position: absolute;\n  left: 18px;\n  bottom: 40px;\n  z-index: 3;\n  background: rgba(255, 255, 255, 0.82);\n  backdrop-filter: blur(18px) saturate(140%);\n  -webkit-backdrop-filter: blur(18px) saturate(140%);\n  padding: 16px 18px;\n  border-radius: 16px;\n  max-width: 320px;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.spotlight-hero__location {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--bv-muted);\n  margin: 0;\n}\n\n.spotlight-hero__location i {\n  color: #5eead4;\n}\n\n.spotlight-hero__title {\n  font-family: var(--bv-font-display);\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.01em;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.spotlight-hero__description {\n  max-width: 570px;\n\n  margin: 0 0 0px;\n\n  color: #64748b;\n\n  font-size: 0.82rem;\n  line-height: 1.6;\n}\n\n/* =========================================================\n   BOOK BUTTON\n   ========================================================= */\n\n.spotlight-hero__button {\n  appearance: none;\n  -webkit-appearance: none;\n\n  display: inline-flex;\n  align-items: center;\n\n  gap: 12px;\n\n  padding: 7px 8px 7px 18px;\n\n  border: 0;\n  border-radius: var(--bv-radius-pill, 999px);\n\n  background: var(--bv-grad-primary);\n  color: #fff;\n\n  font-family: var(--bv-font-display);\n\n  font-size: 0.82rem;\n  font-weight: 800;\n\n  cursor: pointer;\n\n  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.3);\n\n  transition:\n    transform var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease);\n}\n\n.spotlight-hero__button:hover {\n  transform: translateY(-2px);\n\n  box-shadow: 0 12px 26px rgba(20, 184, 166, 0.38);\n}\n\n.spotlight-hero__button span {\n  width: 31px;\n  height: 31px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  background: rgba(255, 255, 255, 0.2);\n\n  color: #fff;\n}\n\n/* =========================================================\n   GALLERY\n   ========================================================= */\n\n.spotlight-gallery {\n  position: absolute;\n  left: 18px;\n  right: 18px;\n  bottom: 18px;\n  z-index: 2;\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 8px;\n  padding: 6px;\n  background: rgba(15, 23, 42, 0.36);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.spotlight-gallery__thumb {\n  appearance: none;\n  -webkit-appearance: none;\n\n  width: 54px;\n  height: 40px;\n\n  padding: 0;\n\n  overflow: hidden;\n\n  border: 2px solid transparent;\n  border-radius: 8px;\n\n  background: rgba(255, 255, 255, 0.35);\n\n  opacity: 0.7;\n\n  cursor: pointer;\n\n  transition:\n    opacity var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease);\n}\n\n.spotlight-gallery__thumb img {\n  width: 100%;\n  height: 100%;\n\n  display: block;\n\n  object-fit: cover;\n}\n\n.spotlight-gallery__thumb:hover {\n  opacity: 1;\n  transform: translateY(-2px);\n}\n\n.spotlight-gallery__thumb--active {\n  opacity: 1;\n\n  border-color: #fff;\n\n  box-shadow: 0 0 0 2px var(--bv-primary);\n}\n\n/* =========================================================\n   EMPTY\n   ========================================================= */\n\n.spotlight-empty {\n  padding: 50px;\n\n  color: var(--bv-muted);\n\n  text-align: center;\n}\n\n/* =========================================================\n   RESPONSIVE\n   ========================================================= */\n\n@media (max-width: 1100px) {\n  .spotlight-layout {\n    grid-template-columns: minmax(220px, 0.8fr) minmax(0, 1.2fr);\n    gap: 18px;\n  }\n\n  .spotlight-hero__card {\n    min-height: 480px;\n  }\n\n  .spotlight-hero__info {\n    left: 24px;\n    right: 24px;\n    bottom: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .spotlight-layout {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .spotlight-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n  }\n\n  .spotlight-item {\n    min-height: 70px;\n    padding: 12px;\n  }\n\n  .spotlight-item__number {\n    width: 30px;\n    height: 30px;\n  }\n\n  .spotlight-hero__card {\n    min-height: 430px;\n    border-radius: 20px;\n  }\n\n  .spotlight-gallery {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .spotlight-list {\n    grid-template-columns: 1fr;\n  }\n\n  .spotlight-hero__card {\n    min-height: 400px;\n  }\n\n  .spotlight-hero__info {\n    left: 18px;\n    right: 18px;\n    bottom: 18px;\n  }\n\n  .spotlight-hero__title {\n    font-size: 1.75rem;\n  }\n\n  .spotlight-hero__description {\n    font-size: 0.75rem;\n  }\n\n  .spotlight-hero__badge {\n    top: 14px;\n    left: 14px;\n  }\n\n  .spotlight-hero__navigation {\n    top: 14px;\n    right: 14px;\n  }\n}\n.bv-featured--hotels .bv-featured__grid {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr);\n}\n\n.bv-featured--hotels .bv-featured__side {\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.bv-featured--hotels .bv-featured__hero {\n  grid-column: 2;\n  grid-row: 1;\n}\n.bv-featured__hero-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 42px;\n  height: 42px;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  border-radius: 50%;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 8;\n  transition: all 0.25s ease;\n}\n\n.bv-featured__hero-arrow:hover {\n  background: #0f766e;\n  border-color: #0f766e;\n  transform: translateY(-50%) scale(1.06);\n}\n\n.bv-featured__hero-arrow--prev {\n  left: 20px;\n}\n\n.bv-featured__hero-arrow--next {\n  right: 20px;\n}\n\n.bv-featured__gallery {\n  position: absolute;\n  left: 24px;\n  right: 24px;\n  bottom: 20px;\n  z-index: 10;\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.bv-featured__gallery::-webkit-scrollbar {\n  display: none;\n}\n\n.bv-featured__gallery-thumb {\n  flex: 0 0 58px;\n  width: 58px;\n  height: 46px;\n  padding: 0;\n  border: 2px solid transparent;\n  border-radius: 9px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n  opacity: 0.7;\n  transition: all 0.25s ease;\n}\n\n.bv-featured__gallery-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.bv-featured__gallery-thumb:hover {\n  opacity: 1;\n  transform: translateY(-2px);\n}\n\n.bv-featured__gallery-thumb.is-active {\n  opacity: 1;\n  border-color: #fff;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n.bv-stage__tag-icon--hotel {\n  background: rgba(20, 184, 166, 0.14);\n  color: #0d9488;\n}\n\n/* =========================================================\n   FEATURED HOTELS — RESPONSIVE FIXES\n   Paste at the END of your stylesheet (after the\n   .bv-featured--hotels overrides).\n   ========================================================= */\n\n/* ---- Price / rating row (replaces inline styles) ---- */\n.bv-featured__hero-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n  margin: 2px 0 4px;\n}\n\n.bv-featured__hero-price {\n  font-family: var(--bv-font-display);\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n}\n\n.bv-featured__hero-price small {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--bv-muted);\n}\n\n.bv-featured__hero-rating {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--bv-ink);\n}\n\n.bv-featured__hero-rating i {\n  color: #fbbf24;\n}\n\n/* ---- Mini card price (now in normal flow, not absolute) ---- */\n.bv-featured__mini-price {\n  margin: 6px 0 0;\n  font-family: var(--bv-font-display);\n  font-size: 0.85rem;\n  font-weight: 800;\n  color: var(--bv-primary-700);\n}\n\n.bv-featured__mini-price small {\n  font-weight: 500;\n  color: var(--bv-muted);\n}\n\n/* =========================================================\n   TABLET (≤1100px): single column, hero on top\n   ========================================================= */\n@media (max-width: 1100px) {\n  .bv-featured--hotels .bv-featured__grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  /* KEY FIX: reset the desktop column placement */\n  .bv-featured--hotels .bv-featured__hero,\n  .bv-featured--hotels .bv-featured__side {\n    grid-column: auto;\n    grid-row: auto;\n  }\n\n  .bv-featured--hotels .bv-featured__hero {\n    order: 1;\n  }\n\n  .bv-featured--hotels .bv-featured__side {\n    order: 2;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-info {\n    bottom: 90px;\n  }\n}\n\n/* =========================================================\n   MOBILE (≤820px)\n   ========================================================= */\n@media (max-width: 820px) {\n  .bv-featured--hotels .bv-featured__side {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  /* Taller card so the info panel doesn't collide with badge/arrows */\n  .bv-featured--hotels .bv-featured__hero-card {\n    aspect-ratio: auto;\n    height: clamp(440px, 120vw, 560px);\n  }\n\n  .bv-featured--hotels .bv-featured__hero-badge {\n    top: 12px;\n    left: 12px;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-arrow {\n    top: 32%;\n    width: 36px;\n    height: 36px;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-arrow--prev {\n    left: 12px;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-arrow--next {\n    right: 12px;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-info {\n    left: 12px;\n    right: 12px;\n    bottom: 76px;\n    max-width: none;\n    padding: 12px 14px;\n  }\n\n  .bv-featured--hotels .bv-featured__gallery {\n    left: 12px;\n    right: 12px;\n    bottom: 12px;\n  }\n\n  .bv-featured--hotels .bv-featured__gallery-thumb {\n    flex: 0 0 52px;\n    width: 52px;\n    height: 40px;\n  }\n\n  .bv-featured--hotels .bv-featured__mini.is-active::before {\n    left: -6px;\n  }\n}\n\n/* =========================================================\n   SMALL PHONES (≤480px)\n   ========================================================= */\n@media (max-width: 480px) {\n  .bv-featured--hotels .bv-featured__hero-card {\n    height: clamp(420px, 125vw, 500px);\n    border-radius: 20px;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-info {\n    left: 10px;\n    right: 10px;\n    bottom: 62px;\n    padding: 10px 12px;\n    gap: 4px;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-info-title {\n    font-size: 1rem;\n  }\n\n  .bv-featured--hotels .bv-featured__hero-info-desc {\n    font-size: 0.72rem;\n  }\n\n  .bv-featured--hotels .bv-featured__gallery {\n    left: 10px;\n    right: 10px;\n    bottom: 10px;\n    gap: 6px;\n  }\n\n  .bv-featured--hotels .bv-featured__gallery-thumb {\n    flex: 0 0 44px;\n    width: 44px;\n    height: 34px;\n    border-radius: 7px;\n  }\n\n  /* Mini cards: drop the arrow column to give text room */\n  .bv-featured--hotels .bv-featured__mini {\n    grid-template-columns: 84px minmax(0, 1fr);\n    gap: 10px;\n    padding: 10px;\n  }\n\n  .bv-featured--hotels .bv-featured__mini-media {\n    width: 84px;\n    height: 84px;\n    border-radius: 12px;\n  }\n\n  .bv-featured--hotels .bv-featured__mini-arrow {\n    display: none;\n  }\n\n  .bv-featured--hotels .bv-featured__mini-desc {\n    -webkit-line-clamp: 1;\n    line-clamp: 1;\n  }\n}\n/* Desktop price (replaces the old inline style) */\n.bv-featured__mini-price-abs {\n  position: absolute;\n  right: 55px;\n  bottom: 18px;\n  font-weight: 700;\n  color: #0f766e;\n  z-index: 3;\n}\n\n/* Mobile row hidden on desktop */\n.bv-featured__mini-mobile {\n  display: none;\n}\n\n/* =========================================================\n   MOBILE: Stay → Price → Arrow only\n   ========================================================= */\n@media (max-width: 820px) {\n  .bv-featured--hotels .bv-featured__mini {\n    grid-template-columns: 84px minmax(0, 1fr);\n    gap: 12px;\n    padding: 10px;\n    align-items: center;\n  }\n\n  .bv-featured--hotels .bv-featured__mini-media {\n    width: 84px;\n    height: 84px;\n    border-radius: 12px;\n  }\n\n  /* hide desktop-only bits */\n  .bv-featured--hotels .bv-featured__mini-desc,\n  .bv-featured--hotels .bv-featured__mini-tags,\n  .bv-featured--hotels .bv-featured__mini-arrow,\n  .bv-featured--hotels .bv-featured__mini-price-abs {\n    display: none;\n  }\n\n  /* let the arrow link sit above the click overlay */\n  .bv-featured--hotels .bv-featured__mini-body {\n    z-index: auto;\n  }\n\n  .bv-featured--hotels .bv-featured__mini-mobile {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 8px;\n    position: relative;\n    z-index: 2;\n    pointer-events: none; /* clicks pass through to overlay… */\n  }\n\n  .bv-featured__mini-stay {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px;\n    border-radius: var(--bv-radius-pill);\n    background: var(--bv-primary-50);\n    border: 1px solid rgba(20, 184, 166, 0.18);\n    color: var(--bv-primary-700);\n    font-size: 0.7rem;\n    font-weight: 700;\n    flex-shrink: 0;\n  }\n\n  .bv-featured__mini-stay i {\n    font-size: 0.7rem;\n  }\n\n  .bv-featured__mini-mprice {\n    font-family: var(--bv-font-display);\n    font-size: 0.9rem;\n    font-weight: 800;\n    color: var(--bv-primary-700);\n    white-space: nowrap;\n  }\n\n  .bv-featured__mini-mprice small {\n    font-size: 0.68rem;\n    font-weight: 500;\n    color: var(--bv-muted);\n    margin-left: 2px;\n  }\n\n  .bv-featured__mini-go {\n    pointer-events: auto; /* …except the arrow */\n    margin-left: auto;\n    width: 36px;\n    height: 36px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: var(--bv-grad-primary);\n    color: #fff;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    text-decoration: none;\n    box-shadow: 0 6px 16px rgba(20, 184, 166, 0.32);\n    transition: transform var(--bv-dur) var(--bv-ease);\n  }\n\n  .bv-featured__mini-go:hover,\n  .bv-featured__mini-go:active {\n    color: #fff;\n    transform: translateX(3px);\n  }\n}\n/* Arrow hamesha overlay ke upar aur clickable rahe */\n.bv-featured__mini-arrow,\n.bv-featured__mini-go {\n  position: relative;\n  z-index: 5 !important;\n  pointer-events: auto !important;\n  border: none;\n  cursor: pointer;\n}\n\n@media (max-width: 820px) {\n  .bv-featured--hotels .bv-featured__mini-body {\n    z-index: auto !important;\n    pointer-events: none;\n  }\n\n  .bv-featured--hotels .bv-featured__mini-mobile {\n    z-index: 5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
